import superAGILogo from "@/src/assets/images/dark/platform/superagi_icon.svg";
import superAGILightLogo from "@/src/assets/images/light/platform/superagi_icon.svg";
import draggableDots from "@/src/assets/images/neutral/grey/draggable_dots.svg";
import resizeGrip from "@/src/assets/images/neutral/grey/resize_grip.svg";
import signalWave from "@/src/assets/images/neutral/grey/signal_wave.svg";
import emptyStateSecondary from "@/src/assets/images/dark/empty_state/empty_state_secondary.svg";
import bottomArrowWhite from "@/src/assets/images/dark/arrows/bottom_arrow_white.svg";
import bottomArrowGrey from "@/src/assets/images/neutral/arrows/bottom_arrow_grey.svg";
import researchSelectedIcon from "@/src/assets/images/dark/selected/research_selected.svg";
import researchSelectedLightIcon from "@/src/assets/images/light/selected/research_selected.svg";
import researchUnselectedIcon from "@/src/assets/images/neutral/unselected/research_unselected.svg";
import analyticsSelectedIcon from "@/src/assets/images/dark/sidebar/selected/analytics.svg";
import businessDetailsSelectedIcon from "@/src/assets/images/dark/selected/business_details.svg";
import businessDetailsSelectedLightIcon from "@/src/assets/images/light/selected/business_details.svg";
import businessDetailsUnselectedIcon from "@/src/assets/images/neutral/unselected/business_details.svg";
import aiSDRSelectedIcon from "@/src/assets/images/dark/sidebar/selected/ai_sdr.svg";
import aiSDRUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/ai_sdr.svg";
import generalSelectedIcon from "@/src/assets/images/dark/selected/general_selected.svg";
import generalSelectedLightIcon from "@/src/assets/images/light/selected/general_selected.svg";
import generalUnselectedIcon from "@/src/assets/images/neutral/unselected/general.svg";
import profileSelectedIcon from "@/src/assets/images/dark/selected/profile.svg";
import profileSelectedLightIcon from "@/src/assets/images/light/selected/profile.svg";
import profileUnselectedIcon from "@/src/assets/images/neutral/unselected/profile.svg";
import integrationsSelectedIcon from "@/src/assets/images/dark/selected/integrations.svg";
import integrationsSelectedLightIcon from "@/src/assets/images/light/selected/integrations.svg";
import integrationsUnselectedIcon from "@/src/assets/images/neutral/unselected/integrations.svg";
import waterfallSelectedIcon from "@/src/assets/images/dark/selected/waterfall.svg";
import waterfallSelectedLightIcon from "@/src/assets/images/light/selected/waterfall.svg";
import waterfallUnselectedIcon from "@/src/assets/images/neutral/common/waterfall.svg";
import emailTemplatesSelectedIcon from "@/src/assets/images/dark/selected/email_templates.svg";
import emailTemplatesSelectedLightIcon from "@/src/assets/images/light/selected/email_templates.svg";
import emailTemplatesUnselectedIcon from "@/src/assets/images/neutral/unselected/email_templates.svg";
import contentSelectedIcon from "@/src/assets/images/dark/sidebar/selected/content.svg";
import contentSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/content.svg";
import usersSelectedIcon from "@/src/assets/images/dark/selected/users.svg";
import usersSelectedLightIcon from "@/src/assets/images/light/selected/users.svg";
import usersUnselectedIcon from "@/src/assets/images/neutral/unselected/users.svg";
import tasksSelectedIcon from "@/src/assets/images/dark/sidebar/selected/tasks.svg";
import tasksSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/tasks.svg";
import tasksUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/tasks.svg";
import tasksUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/tasks.svg";
import outputSelectedIcon from "@/src/assets/images/dark/selected/output_selected.svg";
import outputSelectedLightIcon from "@/src/assets/images/light/selected/output_selected.svg";
import outputUnselectedIcon from "@/src/assets/images/neutral/unselected/output_unselected.svg";
import billingSelectedIcon from "@/src/assets/images/dark/selected/billing.svg";
import billingSelectedLightIcon from "@/src/assets/images/light/selected/billing.svg";
import billingUnselectedIcon from "@/src/assets/images/neutral/unselected/billing.svg";
import voicemailSelectedIcon from "@/src/assets/images/dark/selected/voicemails.svg";
import voicemailSelectedLightIcon from "@/src/assets/images/light/selected/voicemails.svg";
import voicemailUnselectedIcon from "@/src/assets/images/neutral/unselected/voicemails.svg";
import searchIcon from "@/src/assets/images/dark/action/search.svg";
import searchLightIcon from "@/src/assets/images/light/action/search.svg";
import enrichSearchIcon from "@/src/assets/images/light/selected/enrich_search_icon.svg";
import enrichSearchLightIcon from "@/src/assets/images/light/action/enrich_search_icon.svg";
import adsClickIcon from "@/src/assets/images/neutral/common/ads_click.svg";
import filterIconGrey from "@/src/assets/images/neutral/grey/filter_icon.svg";
import filterActive from "@/src/assets/images/dark/selected/filter_active.svg";
import filterActiveLightIcon from "@/src/assets/images/light/selected/filter_active.svg";
import filterIconSelected from "@/src/assets/images/dark/selected/filter_icon_selected.svg";
import chevronArrowLeftGrey from "@/src/assets/images/neutral/arrows/chevron_arrow1.svg";
import chevronArrowRight from "@/src/assets/images/dark/arrows/chevron_arrow2.svg";
import chevronArrowRightLightIcon from "@/src/assets/images/light/arrows/chevron_arrow2.svg";
import discordIcon from "@/src/assets/images/neutral/icon/discord_icon.svg";
import discordLightIcon from "@/src/assets/images/light/icons/discord_icon.svg";
import addIconBlack from "@/src/assets/images/neutral/action/add_icon_black.svg";
import moreIconVertical from "@/src/assets/images/dark/selected/more_icon_vertical.svg";
import moreIconVerticalLightIcon from "@/src/assets/images/light/selected/more_icon_vertical.svg";
import editIcon from "@/src/assets/images/neutral/grey/edit_icon.svg";
import cloneIconGrey from "@/src/assets/images/neutral/grey/clone_icon.svg";
import deleteIconGrey from "@/src/assets/images/neutral/grey/delete_icon.svg";
import closeIconGrey from "@/src/assets/images/neutral/grey/close_icon.svg";
import emailIconGrey from "@/src/assets/images/neutral/grey/email_icon.svg";
import contactsLeadsIcon from "@/src/assets/images/dark/call/contacts_leads.svg";
import contactsLeadsLightIcon from "@/src/assets/images/light/selected/contacts_leads.svg";
import callIconGrey from "@/src/assets/images/neutral/grey/call_icon.svg";
import whatsappIconGrey from "@/src/assets/images/neutral/social/whatsapp_icon.svg";
import actionIcon from "@/src/assets/images/light/selected/action_icon.svg";
import meetingIconGrey from "@/src/assets/images/neutral/grey/meeting_icon.svg";
import noteIcon from "@/src/assets/images/dark/selected/note_icon.svg";
import noteLightIcon from "@/src/assets/images/light/selected/note_icon.svg";
import taskIcon from "@/src/assets/images/dark/selected/task_icon.svg";
import taskLightIcon from "@/src/assets/images/light/selected/task_icon.svg";
import linkedinSelectedIcon from "@/src/assets/images/dark/selected/linkedin_selected.svg";
import linkedinSelectedLightIcon from "@/src/assets/images/light/selected/linkedin_selected.svg";
import linkedinUnSelectedIcon from "@/src/assets/images/neutral/unselected/linkedin_unselected.svg";
import markAsDoneLightIcon from "@/src/assets/images/light/action/mark_as_done_icon.svg";
import markedAsDoneIcon from "@/src/assets/images/neutral/info/marked_as_done_icon.svg";
import leftArrowIcon from "@/src/assets/images/dark/arrows/left_arrow.svg";
import leftArrowLightIcon from "@/src/assets/images/light/arrows/left_arrow.svg";
import leftArrowGreyIcon from "@/src/assets/images/neutral/arrows/left_arrow_grey.svg";
import rightArrowIcon from "@/src/assets/images/dark/arrows/right_arrow.svg";
import rightArrowLightIcon from "@/src/assets/images/light/arrows/right_arrow.svg";
import emptyScreenGreyDarkIcon from "@/src/assets/images/dark/empty_state/empty_screen.svg";
import emptyScreenGreyLightIcon from "@/src/assets/images/light/empty_state/empty_screen.svg";
import chartAndTableEmptyScreenGreyDarkIcon from "@/src/assets/images/dark/empty_state/empty_screen_chart_and_table.svg";
import chartAndTableEmptyScreenGreyLightIcon from "@/src/assets/images/light/empty_state/empty_screen_chart_and_table.svg";
import callLogsEmptyScreenGreyDarkIcon from "@/src/assets/images/dark/empty_state/empty_screen_call_logs.svg";
import callLogsEmptyScreenGreyLightIcon from "@/src/assets/images/light/empty_state/empty_screen_call_logs.svg";
import callQualityEmptyScreenGreyDarkIcon from "@/src/assets/images/dark/empty_state/empty_screen_call_quality.svg";
import callQualityEmptyScreenGreyLightIcon from "@/src/assets/images/light/empty_state/empty_screen_call_quality.svg";
import callCampaignsEmptyScreenDarkIcon from "@/src/assets/images/dark/empty_state/empty_screen_call_campaigns.svg";
import callCampaignsEmptyScreenLightIcon from "@/src/assets/images/light/empty_state/empty_screen_call_campaigns.svg";
import sendsparkIcon from "@/src/assets/images/neutral/icon/sendspark_icon.svg";
import horizontalThreeDots from "@/src/assets/images/dark/action/horizontal_three_dots.svg";
import horizontalThreeDotsLightIcon from "@/src/assets/images/light/action/horizontal_three_dots.svg";
import horizontalThreeDotsGrey from "@/src/assets/images/neutral/grey/horizontal_three_dots_grey.svg";
import backArrowDefaultGrey from "@/src/assets/images/neutral/arrows/back_arrow.svg";
import backArrowWhite from "@/src/assets/images/dark/arrows/back_arrow_white.svg";
import backArrowWhiteLightIcon from "@/src/assets/images/light/arrows/back_arrow_white.svg";
import backArrowVariant1Grey from "@/src/assets/images/neutral/arrows/back_arrow_variant1.svg";
import pipelinesSelectedIcon from "@/src/assets/images/dark/selected/pipelines.svg";
import pipelinesSelectedLightIcon from "@/src/assets/images/light/selected/pipelines.svg";
import pipelinesUnselectedIcon from "@/src/assets/images/neutral/unselected/pipelines.svg";
import replyIcon from "@/src/assets/images/dark/action/reply_icon.svg";
import replyLightIcon from "@/src/assets/images/light/action/reply_icon.svg";
import replyAllIcon from "@/src/assets/images/dark/action/reply_all_icon.svg";
import replyAllLightIcon from "@/src/assets/images/light/action/reply_all_icon.svg";
import forwardIcon from "@/src/assets/images/dark/action/forward_icon.svg";
import forwardIconGrey from "@/src/assets/images/dark/action/forward_icon_grey.svg";
import forwardLightIcon from "@/src/assets/images/light/action/forward_icon.svg";
import sendIconWhite from "@/src/assets/images/dark/action/send_icon_white.svg";
import sendIconBlack from "@/src/assets/images/light/action/send_icon_black.svg";
import searchEmptyScreenGrey from "@/src/assets/images/neutral/action/search_empty_state.svg";
import searchEmptyScreenGreyLightIcon from "@/src/assets/images/light/action/search_empty_state.svg";
import tableViewUnselected from "@/src/assets/images/neutral/unselected/table_view_unselected.svg";
import tableViewSelected from "@/src/assets/images/dark/selected/table_view_selected.svg";
import tableViewSelectedLightIcon from "@/src/assets/images/light/selected/table_view_selected.svg";
import kanbanViewUnselected from "@/src/assets/images/neutral/unselected/kanban_view_unselected.svg";
import kanbanViewSelected from "@/src/assets/images/dark/selected/kanban_view_selected.svg";
import kanbanViewSelectedLightIcon from "@/src/assets/images/light/selected/kanban_view_selected.svg";
import highPriority from "@/src/assets/images/neutral/info/high_priority.svg";
import lowPriority from "@/src/assets/images/neutral/info/low_priority.svg";
import mediumPriority from "@/src/assets/images/neutral/info/medium_priority.svg";
import plusIcon from "@/src/assets/images/dark/action/plus_icon.svg";
import plusLightIcon from "@/src/assets/images/light/action/plus_icon.svg";
import removeIconGrey from "@/src/assets/images/neutral/grey/remove.svg";
import tickIconGrey from "@/src/assets/images/neutral/grey/tick_icon.svg";
import tickIconWhite from "@/src/assets/images/dark/selected/tick_icon_white.svg";
import tickIconWhiteLightIcon from "@/src/assets/images/light/action/tick_icon_white.svg";
import boldTickIconGrey from "@/src/assets/images/neutral/grey/bold_tick_icon.svg";
import manualIconGrey from "@/src/assets/images/neutral/grey/manual_icon.svg";
import addIcon from "@/src/assets/images/dark/selected/add_icon.svg";
import addLightIcon from "@/src/assets/images/light/action/add_icon.svg";
import completeCampaignStep from "@/src/assets/images/dark/selected/completed_step.svg";
import completeCampaignStepLightIcon from "@/src/assets/images/light/action/complete_campaign_step.svg";
import progressCampaignStep from "@/src/assets/images/dark/selected/progress_campaign_step.svg";
import progressCampaignStepLightIcon from "@/src/assets/images/light/selected/progress_campaign_step.svg";
import remainingCampaignStep from "@/src/assets/images/dark/action/remaining_campaign_step.svg";
import remainingCampaignStepLightIcon from "@/src/assets/images/light/action/remaining_campaign_step.svg";
import previewLeads from "@/src/assets/images/dark/selected/preview_leads.svg";
import previewLeadsLightIcon from "@/src/assets/images/light/selected/preview_leads.svg";
import dustbinIconGrey from "@/src/assets/images/neutral/grey/dustbin.svg";
import emailStep from "@/src/assets/images/dark/action/email_step.svg";
import emailStepLightIcon from "@/src/assets/images/light/action/email_step.svg";
import questionMark from "@/src/assets/images/dark/action/question_mark.svg";
import questionMarkLightIcon from "@/src/assets/images/light/action/question_mark.svg";
import agiMark from "@/src/assets/images/neutral/platform/agi_mark.svg";
import automationDarkIcon from "@/src/assets/images/dark/action/automation_icon.svg";
import automationLightIcon from "@/src/assets/images/light/action/automation_icon.svg";
import arrowDownTooltipGrey from "@/src/assets/images/neutral/arrows/arrow_down_tooltip.svg";
import calendarEditGrey from "@/src/assets/images/neutral/grey/edit_calendar.svg";
import crossMark from "@/src/assets/images/neutral/action/cross_mark.svg";
import tickMark from "@/src/assets/images/neutral/action/tick_mark.svg";
import buildFromScratchIcon from "@/src/assets/images/neutral/action/build_from_scratch_icon.svg";
import noTemplateIconGrey from "@/src/assets/images/neutral/grey/no_template_icon.svg";
import downArrowIconGrey from "@/src/assets/images/neutral/arrows/down_arrow.svg";
import mailIconGrey from "@/src/assets/images/neutral/grey/mail_icon.svg";
import curlyBraceIconGrey from "@/src/assets/images/neutral/grey/curly_braces_icon.svg";
import curlyBraceWithLightningIcon from "@/src/assets/images/neutral/platform/curly_braces_with_lightning_icon.svg";
import stackedEmailGrey from "@/src/assets/images/neutral/grey/stacked_email.svg";
import settingsIconGrey from "@/src/assets/images/neutral/grey/settings_icon.svg";
import logoutIconGrey from "@/src/assets/images/neutral/grey/logout_icon.svg";
import addIconGrey from "@/src/assets/images/neutral/grey/add_icon_grey.svg";
import linkIcon from "@/src/assets/images/dark/action/link_icon.svg";
import linkLightIcon from "@/src/assets/images/light/action/link_icon.svg";
import sortingArrowGrey from "@/src/assets/images/dark/arrows/sorting_arrow.svg";
import sortingArrowGreyLightIcon from "@/src/assets/images/light/arrows/sorting_arrow.svg";
import sortingArrowSelected from "@/src/assets/images/dark/arrows/sorting_arrow_selected.svg";
import sortingArrowSelectedLightIcon from "@/src/assets/images/light/arrows/sorting_arrow_selected.svg";
import emojiIconGrey from "@/src/assets/images/neutral/grey/emoji_icon.svg";
import isTypingIcon from "@/src/assets/images/dark/loaders/is_typing.gif";
import isTypingLightIcon from "@/src/assets/images/light/loaders/is_typing.gif";
import infoIcon from "@/src/assets/images/dark/selected/info_icon.svg";
import infoLightIcon from "@/src/assets/images/light/selected/info_icon.svg";
import gmailLogo from "@/src/assets/images/neutral/integrations/gmail_logo.svg";
import emailIconBlack from "@/src/assets/images/light/selected/email_icon_black.svg";
import emailIconBlackLightIcon from "@/src/assets/images/light/action/email_icon_black.svg";
import noNotificationsIconGrey from "@/src/assets/images/neutral/grey/no_notifications.svg";
import noNotificationsIconGreyLightIcon from "@/src/assets/images/light/unselected/no_notifications.svg";
import moreIconVerticalDisabled from "@/src/assets/images/dark/unselected/more_icon_vertical_disabled.svg";
import moreIconVerticalDisabledLightIcon from "@/src/assets/images/light/unselected/more_icon_vertical_disabled.svg";
import linkedinIconGrey from "@/src/assets/images/neutral/grey/linkedin_icon.svg";
import linkedinStep from "@/src/assets/images/dark/selected/linkedin_step.svg";
import linkedinStepLightIcon from "@/src/assets/images/light/icons/linkedin_step.svg";
import suitcaseLightIcon from "@/src/assets/images/light/icons/suitcase_light.svg";
import suitcaseDarkIcon from "@/src/assets/images/dark/icons/suitcase_dark.svg";
import smsIconGrey from "@/src/assets/images/neutral/grey/sms_icon.svg";
import copyIconGrey from "@/src/assets/images/neutral/grey/copy_icon.svg";
import checkIconBlack from "@/src/assets/images/dark/selected/check_icon_black.svg";
import checkIconBlackLightIcon from "@/src/assets/images/light/selected/check_icon_black.svg";
import attachFileIconGrey from "@/src/assets/images/neutral/grey/attach_file_icon.svg";
import checkIcon from "@/src/assets/images/neutral/action/approve_outreach_icon.svg";
import downloadIconGrey from "@/src/assets/images/neutral/grey/download_icon.svg";
import printIconGrey from "@/src/assets/images/neutral/grey/print_icon_grey.svg";
import campaignTemplatesUnselectedIcon from "@/src/assets/images/neutral/unselected/campaign_templates.svg";
import campaignTemplatesSelectedIcon from "@/src/assets/images/dark/selected/campaign_templates.svg";
import campaignTemplatesSelectedLightIcon from "@/src/assets/images/light/selected/campaign_templates.svg";
import conversationsBlankGrey from "@/src/assets/images/neutral/grey/conversation_blank.svg";
import conversationsBlankGreyLightIcon from "@/src/assets/images/light/selected/conversation_blank.svg";
import outlookLogo from "@/src/assets/images/neutral/integrations/outlook_logo.svg";
import superAGILogoRound from "@/src/assets/images/neutral/platform/superagi_logo_round.svg";
import uploadIconGrey from "@/src/assets/images/neutral/grey/upload_icon.svg";
import csvFileIcon from "@/src/assets/images/neutral/file_types/csv_file_icon.svg";
import previewLightIcon from "@/src/assets/images/light/selected/preview_icon.svg";
import mailboxesSelected from "@/src/assets/images/dark/selected/mailboxes_selected.svg";
import mailboxesSelectedLightIcon from "@/src/assets/images/light/selected/mailboxes_selected.svg";
import mailboxesUnselected from "@/src/assets/images/neutral/unselected/mailboxes_unselected.svg";
import repliesSelectedIcon from "@/src/assets/images/dark/selected/replies.svg";
import repliesUnselectedIcon from "@/src/assets/images/neutral/unselected/replies.svg";
import goToLinkGrey from "@/src/assets/images/neutral/grey/go_to_link.svg";
import trackingDomainSelected from "@/src/assets/images/dark/selected/tracking_domain.svg";
import trackingDomainSelectedLightIcon from "@/src/assets/images/light/selected/tracking_domain.svg";
import trackingDomainUnselected from "@/src/assets/images/neutral/unselected/tracking_domain.svg";
import infoIconGrey from "@/src/assets/images/neutral/grey/info_icon_grey.svg";
import pauseIconGrey from "@/src/assets/images/neutral/grey/pause_icon.svg";
import playIconGrey from "@/src/assets/images/neutral/action/play_icon.svg";
import voiceAgentPlayLight from "@/src/assets/images/light/action/circle_play_icon.svg";
import voiceAgentPauseLight from "@/src/assets/images/light/action/circle_pause_icon.svg";
import voiceAgent from "@/src/assets/images/dark/selected/voice_agent_dark_icon.svg";
import voiceAgentLight from "@/src/assets/images/light/selected/voice_agent_icon.svg";
import multilingualFlag from "@/src/assets/images/neutral/country/multilingual.svg";
import greenDot from "@/src/assets/images/neutral/info/green_dot.svg";
import orangeDot from "@/src/assets/images/neutral/info/orange_dot.svg";
import redDot from "@/src/assets/images/neutral/info/red_dot.svg";
import whiteDot from "@/src/assets/images/neutral/info/white_dot.svg";
import whiteDotLightIcon from "@/src/assets/images/light/selected/white_dot.svg";
import blackDot from "@/src/assets/images/neutral/info/black_dot.svg";
import warmupIcon from "@/src/assets/images/dark/action/warm_up_icon.svg";
import warmupLightIcon from "@/src/assets/images/light/action/warm_up_icon.svg";
import resumeIconBlack from "@/src/assets/images/dark/action/resume_icon_black.svg";
import resumeIconBlackLightIcon from "@/src/assets/images/light/action/resume_icon_black.svg";
import resumeIconWhite from "@/src/assets/images/dark/action/resume_icon_white.svg";
import resumeIconGrey from "@/src/assets/images/neutral/action/resume_icon_grey.svg";
import resumeIconGreyLightIcon from "@/src/assets/images/light/action/resume_icon_grey.svg";
import checkGreenIcon from "@/src/assets/images/neutral/info/check_green_icon.svg";
import clockIcon from "@/src/assets/images/dark/selected/clock_icon.svg";
import clockLightIcon from "@/src/assets/images/light/selected/clock_icon.svg";
import rightArrowDefault from "@/src/assets/images/dark/arrows/right_arrow_default.svg";
import rightArrowDefaultLightIcon from "@/src/assets/images/light/arrows/right_arrow_default.svg";
import warningIconTriangle from "@/src/assets/images/neutral/alerts/warning_triangle.svg";
import activityIcon from "@/src/assets/images/dark/selected/activity_icon.svg";
import activityLightIcon from "@/src/assets/images/light/selected/activity_icon.svg";
import analyticsIcon from "@/src/assets/images/dark/selected/analytics_icon.svg";
import analyticsLightIcon from "@/src/assets/images/light/selected/analytics_icon.svg";
import overviewIcon from "@/src/assets/images/dark/action/overview_icon.svg";
import overviewLightIcon from "@/src/assets/images/light/selected/overview_icon.svg";
import dealsGreyIcon from "@/src/assets/images/neutral/grey/deals.svg";
import leadsGreyIcon from "@/src/assets/images/neutral/grey/leads.svg";
import analyticsGreyIcon from "@/src/assets/images/neutral/grey/analytics.svg";
import removeListIconGrey from "@/src/assets/images/neutral/grey/remove_list_item.svg";
import lockIconGrey from "@/src/assets/images/neutral/grey/lock_icon.svg";
import lockSelectedIcon from "@/src/assets/images/dark/selected/lock_selected.svg";
import lockSelectedLightIcon from "@/src/assets/images/light/selected/lock_selected.svg";
import lockUnselectedIcon from "@/src/assets/images/neutral/unselected/lock_unselected.svg";
import contactsGreyIcon from "@/src/assets/images/neutral/grey/contacts.svg";
import contactsLeadsGreyIcon from "@/src/assets/images/neutral/action/contacts_leads_grey.svg";
import companiesGreyIcon from "@/src/assets/images/neutral/grey/companies.svg";
import aiSDRGreyIcon from "@/src/assets/images/neutral/grey/ai_sdr.svg";
import exportIconGrey from "@/src/assets/images/neutral/grey/export_icon.svg";
import bottomArrowBlackIcon from "@/src/assets/images/dark/arrows/bottom_arrow_black.svg";
import bottomArrowBlackLightIcon from "@/src/assets/images/light/arrows/bottom_arrow_black.svg";
import rightArrowSmallGrey from "@/src/assets/images/neutral/arrows/right_arrow_small.svg";
import signatureIconGrey from "@/src/assets/images/neutral/grey/signature_icon.svg";
import addRoundedGreyIcon from "@/src/assets/images/neutral/grey/add_grey_icon.svg";
import linkGreyIcon from "@/src/assets/images/neutral/grey/link_gray_icon.svg";
import sendIconBlackFilled from "@/src/assets/images/dark/action/send_icon_black_filled.svg";
import sendIconBlackFilledLightIcon from "@/src/assets/images/light/action/send_icon_black_filled.svg";
import superAgiNameLogo from "@/src/assets/images/neutral/platform/superagi_name_logo.svg";
import superAgiNameFullLogo from "@/src/assets/images/neutral/platform/superagi_name_logo_full.svg";
import onCallIcon from "@/src/assets/images/dark/call/oncall_icon.svg";
import onCallLightIcon from "@/src/assets/images/light/call/oncall_icon.svg";
import callIconBlack from "@/src/assets/images/dark/call/call_icon_black.svg";
import callIconBlackLightIcon from "@/src/assets/images/light/call/call_icon_black.svg";
import viaIconGrey from "@/src/assets/images/neutral/grey/via_icon.svg";
import starIconGrey from "@/src/assets/images/neutral/grey/star.svg";
import starFilledIconGrey from "@/src/assets/images/neutral/grey/star_filled_grey.svg";
import atTheRateIconGrey from "@/src/assets/images/neutral/grey/at_the_rate.svg";
import atTheRateSelectedIcon from "@/src/assets/images/dark/selected/at_the_rate_selected.svg";
import atTheRateSelectedLightIcon from "@/src/assets/images/light/selected/at_the_rate_selected.svg";
import blockListsUnselected from "@/src/assets/images/neutral/unselected/block_lists.svg";
import blockListsSelected from "@/src/assets/images/dark/selected/block_lists.svg";
import blockListsSelectedLightIcon from "@/src/assets/images/light/selected/block_lists.svg";
import encryptionIconGrey from "@/src/assets/images/neutral/grey/encryption_icon.svg";
import prospectingLinkedinIconGrey from "@/src/assets/images/neutral/grey/prospecting_linkedin_icon.svg";
import linkedin from "@/src/assets/images/neutral/icon/linkedin_icon.svg";
import automaticEmailGrey from "@/src/assets/images/neutral/grey/automatic_email.svg";
import automaticEmailWrapped from "@/src/assets/images/neutral/common/automatic_email_wrapped.svg";
import emailIconWrapped from "@/src/assets/images/dark/selected/manual_email_wrapped.svg";
import emailIconWrappedLightIcon from "@/src/assets/images/light/selected/manual_email_wrapped.svg";
import callIconWrapped from "@/src/assets/images/dark/call/phone_call_wrapped.svg";
import callIconWrappedLightIcon from "@/src/assets/images/light/call/phone_call_wrapped.svg";
import linkedinWrapped from "@/src/assets/images/neutral/icon/linkedin_wrapped.svg";
import removeNoteGrey from "@/src/assets/images/neutral/grey/remove_note.svg";
import selectManualIconGrey from "@/src/assets/images/neutral/grey/select_manual_icon.svg";
import orderedListIconGrey from "@/src/assets/images/neutral/grey/ordered_list_icon.svg";
import prospectingBrowserIconGrey from "@/src/assets/images/neutral/grey/prospecting_browser_icon.svg";
import crmSyncGreyDark from "@/src/assets/images/dark/action/crm_sync_dark.svg";
import crmSyncGreyLight from "@/src/assets/images/light/unselected/crm_sync_light.svg";
import expandIconGrey from "@/src/assets/images/neutral/grey/expand_icon.svg";
import addToSequenceGrey from "@/src/assets/images/neutral/grey/add_to_sequence.svg";
import codeIconGrey from "@/src/assets/images/neutral/grey/code_icon.svg";
import exportSelectedIcon from "@/src/assets/images/dark/selected/export.svg";
import exportSelectedLightIcon from "@/src/assets/images/light/selected/export.svg";
import exportUnSelectedIcon from "@/src/assets/images/neutral/unselected/export.svg";
import clickedIconActive from "@/src/assets/images/dark/selected/clicked_icon_active.svg";
import clickedIconActiveLightIcon from "@/src/assets/images/light/selected/clicked_icon_active.svg";
import clickedIconInactive from "@/src/assets/images/neutral/grey/clicked_icon_inactive.svg";
import clickedIconInactiveLightIcon from "@/src/assets/images/light/unselected/clicked_icon_inactive.svg";
import deliveredIconActive from "@/src/assets/images/dark/action/delivered_icon_active.svg";
import deliveredIconActiveLightIcon from "@/src/assets/images/light/selected/delivered_icon_active.svg";
import deliveredIconInactive from "@/src/assets/images/neutral/grey/delivered_icon_inactive.svg";
import deliveredIconInactiveLightIcon from "@/src/assets/images/light/unselected/delivered_icon_inactive.svg";
import repliedIconActive from "@/src/assets/images/dark/selected/replied_icon_active.svg";
import repliedIconActiveLightIcon from "@/src/assets/images/light/selected/replied_icon_active.svg";
import repliedIconInactive from "@/src/assets/images/dark/unselected/replied_icon_inactive.svg";
import repliedIconInactiveLightIcon from "@/src/assets/images/light/unselected/replied_icon_inactive.svg";
import seenIconActive from "@/src/assets/images/dark/selected/seen_icon_active.svg";
import seenIconActiveLightIcon from "@/src/assets/images/light/selected/seen_icon_active.svg";
import seenIconInactive from "@/src/assets/images/dark/unselected/seen_icon_inactive.svg";
import seenIconInactiveLightIcon from "@/src/assets/images/light/unselected/seen_icon_inactive.svg";
import disconnectIconGrey from "@/src/assets/images/neutral/grey/disconnect_icon.svg";
import userIcon from "@/src/assets/images/dark/selected/user_icon.svg";
import userLightIcon from "@/src/assets/images/light/selected/user_icon.svg";
import roundRobinIconGrey from "@/src/assets/images/neutral/grey/round_robin_icon.svg";
import availabilitySelected from "@/src/assets/images/dark/selected/availability_selected_icon.svg";
import availabilitySelectedLightIcon from "@/src/assets/images/light/selected/availability_selected_icon.svg";
import availabilityUnselected from "@/src/assets/images/neutral/unselected/availability_unselected_icon.svg";
import profileDarkIconPlaceholder from "@/src/assets/images/dark/empty_state/profile_icon_placeholder.svg";
import profileLightIconPlaceholder from "@/src/assets/images/light/empty_state/profile_icon_placeholder.svg";
import googleMeetIcon from "@/src/assets/images/neutral/integrations/google_meet_icon.svg";
import superMeetIcon from "@/src/assets/images/neutral/platform/super_meet_icon.svg";
import calendarIconGrey from "@/src/assets/images/neutral/grey/calendar_icon.svg";
import googleCalendarIcon from "@/src/assets/images/neutral/integrations/google_calendar_icon.svg";
import outlookCalendarIcon from "@/src/assets/images/neutral/integrations/outlook_calendar_icon.svg";
import inverseIconGrey from "@/src/assets/images/neutral/grey/inverse_icon.svg";
import browserLightIcon from "@/src/assets/images/light/selected/browser_icon.svg";
import copyIconUnselected from "@/src/assets/images/dark/unselected/copy_icon.svg";
import copyIconUnselectedLightIcon from "@/src/assets/images/light/unselected/copy_icon.svg";
import assignOwnerIconGrey from "@/src/assets/images/neutral/grey/assign_owner_icon.svg";
import activeDot from "@/src/assets/images/dark/call/active_dot.svg";
import activeDotLightIcon from "@/src/assets/images/light/call/active_dot.svg";
import inactiveDot from "@/src/assets/images/neutral/info/inactive_dot.svg";
import inactiveDotLightIcon from "@/src/assets/images/light/call/inactive_dot.svg";
import loadBalancingIconGrey from "@/src/assets/images/neutral/grey/load_balance_icon.svg";
import calendarTickIconGrey from "@/src/assets/images/neutral/grey/calendar_tick_icon.svg";
import minusIcon from "@/src/assets/images/dark/action/minus_icon.svg";
import microphone from "@/src/assets/images/neutral/action/microphone_icon.svg";
import voiceAiIcon from "@/src/assets/images/neutral/action/voice_ai_icon.svg";
import voiceAiIconDark from "@/src/assets/images/neutral/action/voice_ai_icon_dark.svg";
import minusLightIcon from "@/src/assets/images/light/action/minus_icon.svg";
import objectSelectedIcon from "@/src/assets/images/dark/selected/objects_selected_icon.svg";
import objectSelectedLightIcon from "@/src/assets/images/light/selected/objects_selected_icon.svg";
import objectUnselectedIcon from "@/src/assets/images/neutral/unselected/objects_unselected_icon.svg";
import enclosedCrossGrey from "@/src/assets/images/neutral/grey/enclosed_cross.svg";
import crossGreyIcon from "@/src/assets/images/neutral/grey/cross_grey_icon.svg";
import bannerCrossIcon from "@/src/assets/images/dark/action/banner_cross_icon.svg";
import skipIcon from "@/src/assets/images/dark/action/skip_icon.svg";
import checkIconRoundedBlack from "@/src/assets/images/dark/selected/check_icon_rounded_black.svg";
import checkIconRoundedWhite from "@/src/assets/images/dark/selected/check_icon_rounded_white.svg";
import checkIconRoundedWhiteLightIcon from "@/src/assets/images/light/selected/check_icon_rounded_white.svg";
import checkIconRoundedWhiteEmpty from "@/src/assets/images/dark/selected/check_icon_rounded_white_empty.svg";
import checkIconRoundedWhiteEmptyLightIcon from "@/src/assets/images/light/selected/check_icon_rounded_white_empty.svg";
import backToTasksIcon from "@/src/assets/images/dark/action/back_to_tasks_icon.svg";
import upArrowIcon from "@/src/assets/images/dark/arrows/up_arrow_icon.svg";
import upArrowIconLightIcon from "@/src/assets/images/light/arrows/up_arrow_icon.svg";
import downArrowWhiteIcon from "@/src/assets/images/dark/arrows/down_arrow_white_large.svg";
import downArrowWhiteLightIcon from "@/src/assets/images/light/arrows/down_arrow_white_large.svg";
import previewEyeIconGrey from "@/src/assets/images/neutral/grey/preview_eye_icon.svg";
import emptyQuestionIconGrey from "@/src/assets/images/dark/empty_state/empty_questions_icon.svg";
import blackPlusIcon from "@/src/assets/images/dark/action/plus_icon_black.svg";
import blackPlusLightIcon from "@/src/assets/images/light/selected/plus_icon_black.svg";
import embedElementIcon from "@/src/assets/images/neutral/card/embed_element_icon.svg";
import embedInlineIcon from "@/src/assets/images/neutral/card/inline_embed_icon.svg";
import emptySignalsIconGrey from "@/src/assets/images/dark/empty_state/empty_signals_icon.svg";
import emptySignalsIconGreyLight from "@/src/assets/images/light/empty_state/empty_signals_icon.svg";
import signalsLow from "@/src/assets/images/neutral/info/signals_low.svg";
import signalsHigh from "@/src/assets/images/neutral/info/signals_high.svg";
import signalsMedium from "@/src/assets/images/neutral/info/signals_medium.svg";
import viewDetailsIcon from "@/src/assets/images/dark/action/view_details_icon.svg";
import viewDetailsLightIcon from "@/src/assets/images/light/action/view_details_icon.svg";
import viewDetailsExpandIconGrey from "@/src/assets/images/neutral/grey/view_details_expand_icon.svg";
import accessFolderGreyIcon from "@/src/assets/images/neutral/grey/access_folder_icon.svg";
import attachFileIconWhite from "@/src/assets/images/dark/selected/attach_file_icon_white.svg";
import attachFileIconWhiteLightIcon from "@/src/assets/images/light/action/attach_file_icon_white.svg";
import uploadIcon1Grey from "@/src/assets/images/neutral/grey/upload_icon_1.svg";
import boldIconWhite from "@/src/assets/images/dark/quill/bold_icon_white.svg";
import boldIconWhiteLightIcon from "@/src/assets/images/light/quill/bold_icon_white.svg";
import italicIconWhite from "@/src/assets/images/dark/quill/italic_icon_white.svg";
import italicIconWhiteLightIcon from "@/src/assets/images/light/quill/italic_icon_white.svg";
import underlineIconWhite from "@/src/assets/images/dark/quill/underline_icon_white.svg";
import underlineIconWhiteLightIcon from "@/src/assets/images/light/quill/underline_icon_white.svg";
import linkIconWhite from "@/src/assets/images/dark/quill/link_icon_white.svg";
import linkIconWhiteLightIcon from "@/src/assets/images/light/quill/link_icon_white.svg";
import quoteIconWhite from "@/src/assets/images/dark/quill/quote_icon_white.svg";
import quoteIconWhiteLightIcon from "@/src/assets/images/light/quill/quote_icon_white.svg";
import numberedListIconWhite from "@/src/assets/images/dark/quill/numbered_list_icon_white.svg";
import numberedListIconWhiteLightIcon from "@/src/assets/images/light/quill/numbered_list_icon_white.svg";
import listIconWhite from "@/src/assets/images/dark/quill/list_icon_white.svg";
import listIconWhiteLightIcon from "@/src/assets/images/light/quill/list_icon_white.svg";
import leftAlignIconWhite from "@/src/assets/images/dark/quill/left_align_white.svg";
import leftAlignIconWhiteLightIcon from "@/src/assets/images/light/quill/left_align_white.svg";
import rightAlignIconWhite from "@/src/assets/images/dark/quill/align_right_white.svg";
import rightAlignIconWhiteLightIcon from "@/src/assets/images/light/quill/align_right_white.svg";
import justifyIconWhite from "@/src/assets/images/dark/quill/align_justify_center.svg";
import justifyIconWhiteLightIcon from "@/src/assets/images/light/quill/align_justify_center.svg";
import alignCenterIconWhite from "@/src/assets/images/dark/quill/align_center_white.svg";
import alignCenterIconWhiteLightIcon from "@/src/assets/images/light/quill/align_center_white.svg";
import leftAlignIcon from "@/src/assets/images/light/quill/left_align_icon.svg";
import imageIconWhite from "@/src/assets/images/dark/quill/image_icon_white.svg";
import imageIconWhiteLightIcon from "@/src/assets/images/light/quill/image_icon_white.svg";
import clearFormattingIconWhite from "@/src/assets/images/dark/quill/clear_formatting_icon_white.svg";
import clearFormattingIconWhiteLightIcon from "@/src/assets/images/light/quill/clear_formatting_icon_white.svg";
import bookmarkIconGrey from "@/src/assets/images/neutral/grey/bookmark_icon.svg";
import billingIconGrey from "@/src/assets/images/neutral/grey/billing_icon.svg";
import formIcon from "@/src/assets/images/dark/selected/form_icon.svg";
import formLightIcon from "@/src/assets/images/light/selected/form_icon.svg";
import revokeIconGrey from "@/src/assets/images/neutral/grey/revoke_icon.svg";
import switchIconGrey from "@/src/assets/images/neutral/grey/switch_icon.svg";
import notAllowedIconGrey from "@/src/assets/images/neutral/grey/not_allowed_icon.svg";
import uploadCsvIconGrey from "@/src/assets/images/neutral/grey/upload_csv.svg";
import checkListIconGrey from "@/src/assets/images/neutral/grey/checklist_icon.svg";
import marketResearchIconGrey from "@/src/assets/images/neutral/grey/market_research_icon.svg";
import qualificationIconGrey from "@/src/assets/images/neutral/grey/qualification_icon.svg";
import multiThreadingIconGrey from "@/src/assets/images/neutral/grey/multi_threading_icon.svg";
import nextBestActionIconGrey from "@/src/assets/images/neutral/grey/next_best_action_icon.svg";
import endIconWhite from "@/src/assets/images/dark/selected/end_icon_white.svg";
import endIconWhiteLightIcon from "@/src/assets/images/light/selected/end_icon_white.svg";
import documentIconGrey from "@/src/assets/images/neutral/grey/document_icon_grey.svg";
import imageIconGrey from "@/src/assets/images/neutral/image_icon_grey.svg";
import videoIconGrey from "@/src/assets/images/neutral/video_icon_grey.svg";
import cameraIconGrey from "@/src/assets/images/neutral/camera_icon_grey.svg";
import sendIconGrey from "@/src/assets/images/neutral/grey/send_icon_gray.svg";
import noteIconGrey from "@/src/assets/images/neutral/grey/note_grey_icon.svg";
import goToLinkWhite from "@/src/assets/images/dark/action/go_to_link_white.svg";
import goToLinkWhiteLightIcon from "@/src/assets/images/light/action/go_to_link_white.svg";
import appCollection from "@/src/assets/images/dark/selected/app_collection.svg";
import appCollectionLightIcon from "@/src/assets/images/light/selected/app_collection.svg";
import addStepIconGrey from "@/src/assets/images/neutral/grey/add_step_icon.svg";
import backspaceIconGrey from "@/src/assets/images/neutral/grey/backspace_icon.svg";
import cancelIconGrey from "@/src/assets/images/neutral/grey/cancel_icon.svg";
import existingLeadIconGrey from "@/src/assets/images/neutral/common/existing_lead.svg";
import existingContactIconGrey from "@/src/assets/images/neutral/common/existing_contact.svg";
import superSalesAppLogo from "@/src/assets/images/neutral/platform/super_sales_app_logo.svg";
import appQr from "@/src/assets/images/neutral/platform/app_qr.svg";
import downloadFromGooglePlay from "@/src/assets/images/neutral/action/download_from_google_play.svg";
import downloadFromAppStore from "@/src/assets/images/neutral/action/download_from_app_store.svg";
import setupForm from "@/src/assets/images/dark/action/setup_form.svg";
import setupFormLightIcon from "@/src/assets/images/light/action/setup_form.svg";
import defineRouting from "@/src/assets/images/dark/action/define_routing.svg";
import defineRoutingLightIcon from "@/src/assets/images/light/action/define_routing.svg";
import responseLogs from "@/src/assets/images/dark/selected/response_logs.svg";
import responseLogsLightIcon from "@/src/assets/images/light/selected/response_logs.svg";
import whiteEnrichSearchIcon from "@/src/assets/images/dark/selected/white_enrich_search_icon.svg";
import whiteEnrichSearchLightIcon from "@/src/assets/images/light/selected/white_enrich_search_icon.svg";
import calculatorIcon from "@/src/assets/images/neutral/grey/calculator_icon.svg";
import blackTickIcon from "@/src/assets/images/dark/selected/black_tick_icon.svg";
import greenCheckIcon from "@/src/assets/images/neutral/action/green_check_icon.svg";
import redCloseIcon from "@/src/assets/images/neutral/action/red_close_icon.svg";
import closeIconGreyFilled from "@/src/assets/images/neutral/grey/close_icon_filled.svg";
import promptIcon from "@/src/assets/images/dark/selected/bulb_icon.svg";
import promptLightIcon from "@/src/assets/images/light/selected/bulb_icon.svg";
import roundedQuestionMark from "@/src/assets/images/neutral/platform/question_mark_rounded_border.svg";
import zoomIcon from "@/src/assets/images/neutral/icon/zoom_icon.svg";
import fileIcon from "@/src/assets/images/neutral/grey/file_icon.svg";
import msTeamsIcon from "@/src/assets/images/neutral/integrations/ms_teams_icon.svg";
import roundedQuestionMarkLightIcon from "@/src/assets/images/light/platform/question_mark_rounded_border.svg";
import addTaskIconGrey from "@/src/assets/images/neutral/grey/add_task.svg";
import apiKeysSelected from "@/src/assets/images/dark/selected/api_keys.svg";
import apiKeysSelectedLightIcon from "@/src/assets/images/light/selected/api_keys.svg";
import apiKeysUnselected from "@/src/assets/images/neutral/unselected/api_keys.svg";
import customEventsSelected from "@/src/assets/images/dark/selected/custom_events.svg";
import customEventsSelectedLightIcon from "@/src/assets/images/light/selected/custom_events.svg";
import customEventsUnselected from "@/src/assets/images/neutral/unselected/custom_events.svg";
import pauseVariant1DarkIcon from "@/src/assets/images/dark/action/pause_variant1_icon.svg";
import pauseVariant1LightIcon from "@/src/assets/images/light/action/pause_variant1_icon.svg";
import activeStep from "@/src/assets/images/dark/selected/active_step.svg";
import USFlag from "@/src/assets/images/neutral/country/us.svg";
import CAFlag from "@/src/assets/images/neutral/country/ca.svg";
import UKFlag from "@/src/assets/images/neutral/country/uk.svg";
import NZFlag from "@/src/assets/images/neutral/country/nz.svg";
import CHFlag from "@/src/assets/images/neutral/country/ch.svg";
import INFlag from "@/src/assets/images/neutral/country/in.svg";
import AUFlag from "@/src/assets/images/neutral/country/au.svg";
import SGFlag from "@/src/assets/images/neutral/country/sg.svg";
import BRFlag from "@/src/assets/images/neutral/country/br.svg";
import IEFlag from "@/src/assets/images/neutral/country/ie.svg";
import MYFlag from "@/src/assets/images/neutral/country/my.svg";
import autoThemeIconGrey from "@/src/assets/images/neutral/grey/auto_theme.svg";
import darkThemeIconGrey from "@/src/assets/images/neutral/grey/dark_theme.svg";
import lightThemeIconGrey from "@/src/assets/images/neutral/grey/light_theme.svg";
import repliedIconGreen from "@/src/assets/images/neutral/action/replied_icon_green.svg";
import deliveredIconGreen from "@/src/assets/images/neutral/action/delivered_icon_green.svg";
import seenIconGreen from "@/src/assets/images/neutral/action/seen_icon_green.svg";
import clickedIconGreen from "@/src/assets/images/neutral/action/clicked_icon_green.svg";
import entityScoringUnselectedIcon from "@/src/assets/images/neutral/unselected/entity_scoring.svg";
import entityScoringSelectedIcon from "@/src/assets/images/dark/selected/entity_scoring.svg";
import entityScoringSelectedLightIcon from "@/src/assets/images/light/selected/entity_scoring.svg";
import lowPriorityTagIcon from "@/src/assets/images/neutral/info/low_priority_tag.svg";
import mediumPriorityTagIcon from "@/src/assets/images/neutral/info/medium_priority_tag.svg";
import highPriorityTagIcon from "@/src/assets/images/neutral/info/high_priority_tag.svg";
import outlinedQuestionMark from "@/src/assets/images/dark/action/outlined_question_mark.svg";
import outlinedQuestionMarkLightIcon from "@/src/assets/images/light/selected/outlined_question_mark.svg";
import domainSelected from "@/src/assets/images/dark/selected/domain.svg";
import domainSelectedLightIcon from "@/src/assets/images/light/selected/domain.svg";
import domainUnselected from "@/src/assets/images/neutral/unselected/domain.svg";
import prospectSearchDarkIcon from "@/src/assets/images/dark/action/prospect_search_icon.svg";
import prospectSearchLightIcon from "@/src/assets/images/light/selected/prospect_search_icon.svg";
import syncIconGrey from "@/src/assets/images/neutral/grey/sync_icon_grey.svg";
import businessNameIcon from "@/src/assets/images/neutral/common/buss_name.svg";
import retryIconGrey from "@/src/assets/images/neutral/grey/retry_icon.svg";
import checkCircleIcon from "@/src/assets/images/neutral/action/check_circle.svg";
import checkCircleDisabledIcon from "@/src/assets/images/neutral/action/check_circle_disabled.svg";
import verifiedYellowIcon from "@/src/assets/images/neutral/action/verified_yellow.svg";
import addVariant1WhiteIcon from "@/src/assets/images/neutral/action/add_variant1_white.svg";
import removeVariant1BlackIcon from "@/src/assets/images/neutral/action/remove_variant1_black.svg";
import verticalWhiteLine from "@/src/assets/images/neutral/action/vertical_white_line.svg";
import validationGreenTickIcon from "@/src/assets/images/neutral/action/validation_green_tick.svg";
import validationStepErrorIcon from "@/src/assets/images/neutral/action/validation_step_error.svg";
import recommendedProspectsDark from "@/src/assets/images/dark/action/recommended_prospects.svg";
import toLeftArrow from "@/src/assets/images/neutral/grey/to_left_arrow.svg";
import exportMailboxDarkIcon from "@/src/assets/images/dark/action/export_mailbox_dark_icon.svg";
import exportMailboxLightIcon from "@/src/assets/images/light/selected/export_mailbox_light_icon.svg";

import whatsNewDarkIcon from "@/src/assets/images/dark/action/whats_new_icon.svg";
import whatsNewLightIcon from "@/src/assets/images/light/action/whats_new_icon.svg";
import whatsappSelectedDarkIcon from "@/src/assets/images/dark/selected/whatsapp_selected_dark.svg";
import whatsappSelectedLightIcon from "@/src/assets/images/light/selected/whatsapp_selected_light.svg";
import notificationDarkIcon from "@/src/assets/images/dark/action/notifications.svg";
import notificationLightIcon from "@/src/assets/images/light/action/notifications.svg";
import superAGIAcademyDarkIcon from "@/src/assets/images/dark/internal/superagi_academy_icon.svg";
import superAGIAcademyLightIcon from "@/src/assets/images/light/internal/superagi_academy_icon.svg";
import emailActionDarkIcon from "@/src/assets/images/dark/action/email_action.svg";
import emailActionLightIcon from "@/src/assets/images/light/action/email_action.svg";
import channelEmailDarkIcon from "@/src/assets/images/dark/channel_email.svg";
import channelEmailLightIcon from "@/src/assets/images/light/channel_email.svg";
import encryptedSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/encrypted.svg";
import encryptedUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/encrypted.svg";
import encryptedSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/encrypted.svg";
import encryptedUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/encrypted.svg";
import contentPasteSearch from "@/src/assets/images/neutral/common/content_paste_search.svg";
import checkCircle2 from "@/src/assets/images/neutral/common/check_circle_2.svg";
import blockRed from "@/src/assets/images/neutral/common/block_red.svg";
import linkIconGrey from "@/src/assets/images/neutral/action/link_grey.svg";

import settingsDarkIcon from "@/src/assets/images/dark/action/settings_icon.svg";
import settingsLightIcon from "@/src/assets/images/light/action/settings_icon.svg";
import tuneDarkIcon from "@/src/assets/images/dark/action/tune_icon.svg";
import tuneLightIcon from "@/src/assets/images/light/action/tune_icon.svg";
import shareNeutralIcon from "@/src/assets/images/neutral/action/share_icon.svg";
import addMemberOption from "@/src/assets/images/neutral/action/add_member_option.svg";
import referIconGrey from "@/src/assets/images/neutral/grey/refer_icon.svg";

import xIconGradient from "@/src/assets/images/neutral/social/x.svg";
import linkedinIconGradient from "@/src/assets/images/neutral/social/linkedin.svg";
import whatsappIconGradient from "@/src/assets/images/neutral/social/whatsapp.svg";
import facebookIconGradient from "@/src/assets/images/neutral/social/facebook.svg";
import emailIconGradient from "@/src/assets/images/neutral/social/email.svg";

import inboundAgentSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/inbound_agent.svg";
import inboundAgentUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/inbound_agent.svg";
import inboundAgentSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/inbound_agent.svg";
import inboundAgentUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/inbound_agent.svg";
import inboxSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/inbox.svg";
import inboxUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/inbox.svg";
import inboxSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/inbox.svg";
import inboxUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/inbox.svg";
import agentInstructionsSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/agent_instructions.svg";
import agentInstructionsUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/agent_instructions.svg";
import agentInstructionsSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/agent_instructions.svg";
import agentInstructionsUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/agent_instructions.svg";
import knowledgeBaseSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/knowledge_base.svg";
import knowledgeBaseUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/knowledge_base.svg";
import knowledgeBaseSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/knowledge_base.svg";
import knowledgeBaseUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/knowledge_base.svg";
import liveChatWidgetSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/live_chat_widget.svg";
import liveChatWidgetUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/live_chat_widget.svg";
import liveChatWidgetSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/live_chat_widget.svg";
import liveChatWidgetUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/live_chat_widget.svg";
import repliedDarkIcon from "@/src/assets/images/dark/action/replied_icon.svg";
import repliedLightIcon from "@/src/assets/images/light/action/replied_icon.svg";
import chatIconDark from "@/src/assets/images/dark/chat/chat.svg";
import chatIconLight from "@/src/assets/images/light/chat/chat.svg";
import boltIcon from "@/src/assets/images/dark/platform/bolt.svg";
const microsoftIcon = "/images/devicon_microsoft.svg";
import sentIconActive from "@/src/assets/images/dark/selected/sent.svg";
import sentIconInactive from "@/src/assets/images/light/selected/not_sent.svg";
import acceptedIconActive from "@/src/assets/images/neutral/action/accepted.svg";
import acceptedIconInactive from "@/src/assets/images/light/selected/not_accepted.svg";

// -------------------- Meeting Images Start -------------------- //
import zoomIntegration from "@/src/assets/images/neutral/integrations/zoom.svg";
import msTeamsIntegration from "@/src/assets/images/neutral/integrations/ms_teams.svg";
import googleMeetIntegration from "@/src/assets/images/neutral/integrations/google_meet.svg";
import talktimeSelectedDark from "@/src/assets/images/dark/meetings/selected/talktime.svg";
import talktimeUnselectedDark from "@/src/assets/images/dark/meetings/unselected/talktime.svg";
import transcriptSelectedDark from "@/src/assets/images/dark/meetings/selected/transcript.svg";
import transcriptUnselectedDark from "@/src/assets/images/dark/meetings/unselected/transcript.svg";
import talktimeSelectedLight from "@/src/assets/images/light/meetings/selected/talktime.svg";
import talktimeUnselectedLight from "@/src/assets/images/light/meetings/unselected/talktime.svg";
import transcriptSelectedLight from "@/src/assets/images/light/meetings/selected/transcript.svg";
import transcriptUnselectedLight from "@/src/assets/images/light/meetings/unselected/transcript.svg";
import meetingIntelligenceSelectedDark from "@/src/assets/images/dark/meetings/selected/meeting_intelligence.svg";
import meetingIntelligenceUnselectedDark from "@/src/assets/images/dark/meetings/unselected/meeting_intelligence.svg";
import meetingIntelligenceSelectedLight from "@/src/assets/images/light/meetings/selected/meeting_intelligence.svg";
import meetingIntelligenceUnselectedLight from "@/src/assets/images/light/meetings/unselected/meeting_intelligence.svg";
import prospectEmptyScreenDark from "@/src/assets/images/dark/empty_state/prospect_empty_screen_icon.svg";
import prospectEmptyScreenLight from "@/src/assets/images/light/empty_state/prospect_empty_screen_icon.svg";

// Sort Arrow Icons
import sortAscendingNeutral from "@/src/assets/images/neutral/action/sort_ascending.svg";
import sortDescendingNeutral from "@/src/assets/images/neutral/action/sort_descending.svg";
import manageColumnsIcon from "@/src/assets/images/neutral/common/manage_columns.svg";
import eyeOffIconGrey from "@/src/assets/images/neutral/action/eye_off_icon.svg";
import eyeIconGrey from "@/src/assets/images/neutral/action/eye_grey.svg";
import plusGreyThin from "@/src/assets/images/neutral/action/plus_grey_thin.svg";
import pinIcon from "@/src/assets/images/neutral/action/pin.svg";
import unpinIcon from "@/src/assets/images/neutral/action/unpin.svg";

// -------------------- Meeting Images End -------------------- //
import redirectGradientIcon from "@/src/assets/images/neutral/action/redirect_gradient.svg";
import playDarkIcon from "@/src/assets/images/dark/action/play_icon.svg";
import playLightIcon from "@/src/assets/images/light/action/play_icon.svg";
import emailVerifiedIcon from "@/src/assets/images/neutral/action/email_verified_icon.svg";
import emailUnverifiedIcon from "@/src/assets/images/neutral/action/email_unverified_icon.svg";

import removedUser from "@/src/assets/images/neutral/common/removed_user.svg";
import campaignsIcon from "@/src/assets/images/dark/selected/campaigns_icon.svg";
import customHtmlIcon from "@/src/assets/images/neutral/grey/custom_html.svg";
import plainTextIcon from "@/src/assets/images/dark/quill/plain_text_icon.svg";
import dragNDropIcon from "@/src/assets/images/neutral/grey/drag_drop_icon.svg";
import mobileIcon from "@/src/assets/images/neutral/grey/mobile_icon.svg";
import desktopIcon from "@/src/assets/images/neutral/grey/desktop_icon.svg";
import recipientsIconGrey from "@/src/assets/images/neutral/grey/recipients_gray_icon.svg";
import recipientsIconWhite from "@/src/assets/images/dark/selected/recipients_white_icon.svg";
import emailCampaignWhiteIcon from "@/src/assets/images/dark/selected/email_campaign_icon.svg";
import marketingUnselectedDarkIcon from "@/src/assets/images/dark/unselected/marketing_unselected_dark_icon.svg";
import marketingUnSelectedLightIcon from "@/src/assets/images/light/unselected/marketing_unselected_light_icon.svg";
import campaignsUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/campaigns_unselected_dark_icon.svg";
import campaignsUnSelectedLightIcon from "@/src/assets/images/dark/sidebar/unselected/campaigns_unselected_light_icon.svg";
import emailCampaignSettingsUnselectedIcon from "@/src/assets/images/neutral/grey/email_campaigns_settings_unselected.svg";
import emailCampaignSettingsSelectedLightIcon from "@/src/assets/images/light/selected/email_campaign_settings_light_icon.svg";
import redInfo from "@/src/assets/images/neutral/info/red_info.svg";
import yellowWarning from "@/src/assets/images/neutral/info/yellow_warning.svg";
import blueAnnouncement from "@/src/assets/images/neutral/info/blue_announcement.svg";
import warningIcon from "@/src/assets/images/neutral/info/warning_icon.svg";
import textEditorBlack from "@/src/assets/images/light/common/text_editor.svg";
import textEditorWhite from "@/src/assets/images/dark/common/text_editor.svg";
import textEditorGrey from "@/src/assets/images/neutral/common/text_editor_grey.svg";
import htmlCodeBlack from "@/src/assets/images/light/common/html_code.svg";
import htmlCodeWhite from "@/src/assets/images/dark/common/html_code.svg";
import htmlCodeGrey from "@/src/assets/images/neutral/common/html_code_grey.svg";
import anonymousIcon from "@/src/assets/images/neutral/common/anonymous_icon.svg";
import msg91Icon from "@/src/assets/images/neutral/common/msg_91.svg";
import superagiFooterIcon from "@/src/assets/images/neutral/icon/superagi_footer_icon.svg";
import onboardingImage from "@/src/assets/images/neutral/platform/onboarding_image.svg";
import doubleArrowIcon from "@/src/assets/images/neutral/common/double_arrow.svg";
import plusGrey from "@/src/assets/images/neutral/action/plus_grey.svg";
import associationsDarkIcon from "@/src/assets/images/dark/common/associations.svg";
import associationsLightIcon from "@/src/assets/images/light/common/associations.svg";
import associationsNeutralIcon from "@/src/assets/images/neutral/common/associations.svg";
import propertiesDarkIcon from "@/src/assets/images/dark/common/properties.svg";
import propertiesLightIcon from "@/src/assets/images/light/common/properties.svg";
import propertiesNeutralIcon from "@/src/assets/images/neutral/common/properties.svg";
import starRateSelectedIcon from "@/src/assets/images/neutral/selected/star_rate_icon.svg";
import starRateUnselectedIcon from "@/src/assets/images/neutral/unselected/star_rate_icon.svg";
import agiAssistantLightning from "@/src/assets/images/neutral/action/agi_assistant_lightning.svg";
import openInFullMode from "@/src/assets/images/neutral/grey/open_in_full.svg";

import unassignedProfile from "@/src/assets/images/neutral/common/unassigned_profile.svg";
import openChatDarkIcon from "@/src/assets/images/dark/action/open_chat_icon.svg";
import openChatLightIcon from "@/src/assets/images/light/action/open_chat_icon.svg";
import openChatNeutralIcon from "@/src/assets/images/neutral/action/open_chat_icon.svg";
import closeChatDarkIcon from "@/src/assets/images/dark/action/close_chat_icon.svg";
import closeChatLightIcon from "@/src/assets/images/light/action/close_chat_icon.svg";
import closeChatNeutralIcon from "@/src/assets/images/neutral/action/close_chat_icon.svg";
import closeVariant1DarkIcon from "@/src/assets/images/dark/action/close_variant1_icon.svg";
import closeVariant1LightIcon from "@/src/assets/images/light/action/close_variant1_icon.svg";

// Property Type Icons
import propertyTypeTextIcon from "@/src/assets/images/neutral/icon/property_type_text.svg";
import propertyTypeNumberIcon from "@/src/assets/images/neutral/icon/property_type_number.svg";
import propertyTypeSelectIcon from "@/src/assets/images/neutral/icon/property_type_select.svg";
import propertyTypeMultiSelectIcon from "@/src/assets/images/neutral/icon/property_type_multi_select.svg";
import propertyTypeDateIcon from "@/src/assets/images/neutral/icon/property_type_date.svg";
import propertyTypeDatetimeIcon from "@/src/assets/images/neutral/icon/property_type_datetime.svg";
import propertyTypeUrlIcon from "@/src/assets/images/neutral/icon/property_type_url.svg";
import propertyTypeEmailIcon from "@/src/assets/images/neutral/icon/property_type_email.svg";
import propertyTypePhoneIcon from "@/src/assets/images/neutral/icon/property_type_phone.svg";
import propertyTypeUserIcon from "@/src/assets/images/neutral/icon/property_type_user.svg";
import propertyTypeBooleanIcon from "@/src/assets/images/neutral/icon/property_type_boolean.svg";
import domainIconGrey from "@/src/assets/images/neutral/icon/domain.svg";

import panelProjectDarkIcon from "@/src/assets/images/dark/action/panel_project_icon.svg";
import panelProjectLightIcon from "@/src/assets/images/light/action/panel_project_icon.svg";
import panelAnalyticsDarkIcon from "@/src/assets/images/dark/action/panel_analytics_icon.svg";
import panelAnalyticsLightIcon from "@/src/assets/images/light/action/panel_analytics_icon.svg";
import panelPropertyDarkIcon from "@/src/assets/images/dark/action/panel_property_icon.svg";
import panelPropertyLightIcon from "@/src/assets/images/light/action/panel_property_icon.svg";
import panelNotesDarkIcon from "@/src/assets/images/dark/action/panel_notes_icon.svg";
import panelNotesLightIcon from "@/src/assets/images/light/action/panel_notes_icon.svg";
import panelRepositoryDarkIcon from "@/src/assets/images/dark/action/panel_repository_icon.svg";
import panelRepositoryLightIcon from "@/src/assets/images/light/action/panel_repository_icon.svg";

import searchIconVariant1DarkIcon from "@/src/assets/images/dark/action/search_icon_variant1.svg";
import searchIconVariant1LightIcon from "@/src/assets/images/light/action/search_icon_variant1.svg";
import renameDarkIcon from "@/src/assets/images/dark/action/rename_icon.svg";
import renameLightIcon from "@/src/assets/images/light/action/rename_icon.svg";
import reorderDarkIcon from "@/src/assets/images/dark/action/reorder_icon.svg";
import reorderLightIcon from "@/src/assets/images/light/action/reorder_icon.svg";
import projectGreyIcon from "@/src/assets/images/neutral/common/project_grey.svg";
import moreIconGrey from "@/src/assets/images/neutral/action/more_icon_grey.svg";
import editV2Icon from "@/src/assets/images/neutral/action/edit_v2.svg";
import arrowOutwardIcon from "@/src/assets/images/neutral/action/arrow_outward.svg";
import websiteUnpublishIcon from "@/src/assets/images/neutral/action/website_unpublish.svg";
import tableGreyIcon from "@/src/assets/images/neutral/common/table.svg";
import boardGreyIcon from "@/src/assets/images/neutral/common/board.svg";
import propertyVisibilityGreyIcon from "@/src/assets/images/neutral/action/property_visibility.svg";
import dashboardGreyIcon from "@/src/assets/images/neutral/action/dashboard.svg";
import cardsGreyIcon from "@/src/assets/images/neutral/action/cards.svg";
import clockGrey from "@/src/assets/images/neutral/common/clock_grey.svg";
import hierarchyIcon from "@/src/assets/images/neutral/common/hierarchy.svg";
import hierarchyDarkIcon from "@/src/assets/images/dark/common/hierarchy.svg";
import hierarchyLightIcon from "@/src/assets/images/light/common/hierarchy.svg";

import customerSuccessDarkSelected from "@/src/assets/images/dark/sidebar/selected/customer_success.svg";
import customerSuccessDarkUnselected from "@/src/assets/images/dark/sidebar/unselected/customer_success.svg";
import customerSuccessLightSelected from "@/src/assets/images/light/sidebar/selected/customer_success.svg";
import customerSuccessLightUnselected from "@/src/assets/images/light/sidebar/unselected/customer_success.svg";
import childObjectGreyIcon from "@/src/assets/images/neutral/common/child_object.svg";
import parentObjectGreyIcon from "@/src/assets/images/neutral/common/parent_object.svg";

import viewAgendaDarkIcon from "@/src/assets/images/dark/action/view_agenda_icon.svg";
import viewAgendaLightIcon from "@/src/assets/images/light/action/view_agenda_icon.svg";
import singleColumnDarkIcon from "@/src/assets/images/dark/layout/single_column.svg";
import singleColumnLightIcon from "@/src/assets/images/light/layout/single_column.svg";
import doubleColumnDarkIcon from "@/src/assets/images/dark/layout/double_column.svg";
import doubleColumnLightIcon from "@/src/assets/images/light/layout/double_column.svg";
import aiCardNeutralIcon from "@/src/assets/images/neutral/card/ai_card_icon.svg";
import tableCardNeutralIcon from "@/src/assets/images/neutral/card/table_card_icon.svg";
import numberCardNeutralIcon from "@/src/assets/images/neutral/card/number_card_icon.svg";
import graphCardNeutralIcon from "@/src/assets/images/neutral/card/graph_card_icon.svg";

import sqlAnalyticsDarkIcon from "@/src/assets/images/dark/analytics/type/sql_icon.svg";
import sqlAnalyticsLightIcon from "@/src/assets/images/light/analytics/type/sql_icon.svg";
import manualAnalyticsDarkIcon from "@/src/assets/images/dark/analytics/type/manual_icon.svg";
import manualAnalyticsLightIcon from "@/src/assets/images/light/analytics/type/manual_icon.svg";
import areaChartDarkIcon from "@/src/assets/images/dark/analytics/chart/area_icon.svg";
import areaChartLightIcon from "@/src/assets/images/light/analytics/chart/area_icon.svg";
import donutChartDarkIcon from "@/src/assets/images/dark/analytics/chart/donut_icon.svg";
import donutChartLightIcon from "@/src/assets/images/light/analytics/chart/donut_icon.svg";
import gaugeChartDarkIcon from "@/src/assets/images/dark/analytics/chart/gauge_icon.svg";
import gaugeChartLightIcon from "@/src/assets/images/light/analytics/chart/gauge_icon.svg";
import horizontalChartDarkIcon from "@/src/assets/images/dark/analytics/chart/horizontal_icon.svg";
import horizontalChartLightIcon from "@/src/assets/images/light/analytics/chart/horizontal_icon.svg";
import kpiChartDarkIcon from "@/src/assets/images/dark/analytics/chart/kpi_icon.svg";
import kpiChartLightIcon from "@/src/assets/images/light/analytics/chart/kpi_icon.svg";
import lineChartDarkIcon from "@/src/assets/images/dark/analytics/chart/line_icon.svg";
import lineChartLightIcon from "@/src/assets/images/light/analytics/chart/line_icon.svg";
import pieChartDarkIcon from "@/src/assets/images/dark/analytics/chart/pie_icon.svg";
import pieChartLightIcon from "@/src/assets/images/light/analytics/chart/pie_icon.svg";
import scatterChartDarkIcon from "@/src/assets/images/dark/analytics/chart/scatter_icon.svg";
import scatterChartLightIcon from "@/src/assets/images/light/analytics/chart/scatter_icon.svg";
import tableChartDarkIcon from "@/src/assets/images/dark/analytics/chart/table_icon.svg";
import tableChartLightIcon from "@/src/assets/images/light/analytics/chart/table_icon.svg";
import verticalChartDarkIcon from "@/src/assets/images/dark/analytics/chart/vertical_icon.svg";
import verticalChartLightIcon from "@/src/assets/images/light/analytics/chart/vertical_icon.svg";
import pivotTableDarkIcon from "@/src/assets/images/dark/analytics/chart/pivot_table_icon.svg";
import pivotTableLightIcon from "@/src/assets/images/light/analytics/chart/pivot_table_icon.svg";
import funnelChartDarkIcon from "@/src/assets/images/dark/analytics/chart/funnel_icon.svg";
import funnelChartLightIcon from "@/src/assets/images/light/analytics/chart/funnel_icon.svg";
import editSquare from "@/src/assets/images/neutral/action/edit_square.svg";
import numberGrey from "@/src/assets/images/neutral/action/number_grey.svg";
import booleanGrey from "@/src/assets/images/neutral/action/boolean_grey.svg";
import percentageGrey from "@/src/assets/images/neutral/action/percentage_icon.svg";
import conversionRateIcon from "@/src/assets/images/neutral/action/conversion_rate_icon.svg";

import addPurpleIcon from "@/src/assets/images/neutral/action/add_purple.svg";
import resizeIcon from "@/src/assets/images/neutral/action/resize.svg";

import emptyChartDarkPlaceholder from "@/src/assets/images/dark/empty_state/empty_chart.svg";
import emptyChartLightPlaceholder from "@/src/assets/images/light/empty_state/empty_chart.svg";

import customerSuccessSettingsSelectedDark from "@/src/assets/images/dark/selected/customer_success_settings.svg";
import customerSuccessSettingsSelectedLight from "@/src/assets/images/light/selected/customer_success_settings.svg";
import customerSuccessSettingsUnselectedDark from "@/src/assets/images/dark/unselected/customer_success_settings.svg";
import customerSuccessSettingsUnselectedLight from "@/src/assets/images/light/unselected/customer_success_settings.svg";
import calculateGreyIcon from "@/src/assets/images/neutral/common/calculate.svg";
import compareArrowsIcon from "@/src/assets/images/neutral/common/compare_arrows.svg";
import checkCircleOutlinedDarkIcon from "@/src/assets/images/dark/action/check_circle_outlined.svg";
import checkCircleOutlinedLightIcon from "@/src/assets/images/light/action/check_circle_outlined.svg";

import moveIconDark from "@/src/assets/images/dark/action/move_icon.svg";
import moveIconLight from "@/src/assets/images/light/action/move_icon.svg";
import appleIconDark from "@/src/assets/images/dark/action/apple_icon.svg";
import appleIconLight from "@/src/assets/images/light/action/apple_icon.svg";
import githubIconDark from "@/src/assets/images/dark/action/github_icon.svg";
import githubIconLight from "@/src/assets/images/light/action/github_icon.svg";

import uniboxSettingsSelectedDark from "@/src/assets/images/dark/selected/unibox_settings.svg";
import uniboxSettingsSelectedLight from "@/src/assets/images/light/selected/unibox_settings.svg";
import uniboxSettingsUnselectedDark from "@/src/assets/images/dark/unselected/unibox_settings.svg";
import uniboxSettingsUnselectedLight from "@/src/assets/images/light/unselected/unibox_settings.svg";

import uniboxSelectedDark from "@/src/assets/images/dark/selected/unibox.svg";
import uniboxSelectedLight from "@/src/assets/images/light/selected/unibox.svg";
import uniboxUnselectedDark from "@/src/assets/images/dark/unselected/unibox.svg";
import uniboxUnselectedLight from "@/src/assets/images/light/unselected/unibox.svg";

import developerToolsSelectedDark from "@/src/assets/images/dark/sidebar/selected/developer_tools.svg";
import developerToolsUnselectedDark from "@/src/assets/images/dark/sidebar/unselected/developer_tools.svg";
import developerToolsSelectedLight from "@/src/assets/images/light/sidebar/selected/developer_tools.svg";
import developerToolsUnselectedLight from "@/src/assets/images/light/sidebar/unselected/developer_tools.svg";
import sandboxSelectedDark from "@/src/assets/images/dark/sidebar/selected/sandbox.svg";
import sandboxUnselectedDark from "@/src/assets/images/dark/sidebar/unselected/sandbox.svg";
import sandboxSelectedLight from "@/src/assets/images/light/sidebar/selected/sandbox.svg";
import sandboxUnselectedLight from "@/src/assets/images/light/sidebar/unselected/sandbox.svg";
import codeIconDark from "@/src/assets/images/dark/action/code.svg";
import codeIconLight from "@/src/assets/images/light/action/code.svg";
import commitsIconDark from "@/src/assets/images/dark/action/commits.svg";
import commitsIconLight from "@/src/assets/images/light/action/commits.svg";
import pullRequestsIconDark from "@/src/assets/images/dark/action/pull_requests.svg";
import pullRequestsIconLight from "@/src/assets/images/light/action/pull_requests.svg";
import forkRepoIconDark from "@/src/assets/images/dark/action/fork_repo.svg";
import forkRepoIconLight from "@/src/assets/images/light/action/fork_repo.svg";
import branchRepoIconDark from "@/src/assets/images/dark/action/branch_repo.svg";
import branchRepoIconLight from "@/src/assets/images/light/action/branch_repo.svg";
import gitActionsIconDark from "@/src/assets/images/dark/action/git_actions.svg";
import gitActionsIconLight from "@/src/assets/images/light/action/git_actions.svg";
import arrowChevron1 from "@/src/assets/images/neutral/arrows/arrow_chevron1.svg";
import personalTokensSelectedDark from "@/src/assets/images/dark/selected/personal_tokens.svg";
import personalTokensUnselectedDark from "@/src/assets/images/dark/unselected/personal_tokens.svg";
import personalTokensSelectedLight from "@/src/assets/images/light/selected/personal_tokens.svg";
import personalTokensUnelectedLight from "@/src/assets/images/light/unselected/personal_tokens.svg";
import sshKeysSelectedDark from "@/src/assets/images/dark/selected/ssh_keys.svg";
import sshKeysUnselectedDark from "@/src/assets/images/dark/unselected/ssh_keys.svg";
import sshKeysSelectedLight from "@/src/assets/images/light/selected/ssh_keys.svg";
import sshKeysUnselectedLight from "@/src/assets/images/light/unselected/ssh_keys.svg";
import repoSettingsSelectedDark from "@/src/assets/images/dark/selected/repo_settings.svg";
import repoSettingsUnselectedDark from "@/src/assets/images/dark/unselected/repo_settings.svg";
import repoSettingsSelectedLight from "@/src/assets/images/light/selected/repo_settings.svg";
import repoSettingsUnselectedLight from "@/src/assets/images/light/unselected/repo_settings.svg";
import repoBranchesSelectedDark from "@/src/assets/images/dark/selected/repo_branches.svg";
import repoBranchesUnselectedDark from "@/src/assets/images/dark/unselected/repo_branches.svg";
import repoBranchesSelectedLight from "@/src/assets/images/light/selected/repo_branches.svg";
import repoBranchesUnselectedLight from "@/src/assets/images/light/unselected/repo_branches.svg";
import repoWebhooksSelectedDark from "@/src/assets/images/dark/selected/repo_webhooks.svg";
import repoWebhooksUnselectedDark from "@/src/assets/images/dark/unselected/repo_webhooks.svg";
import repoWebhooksSelectedLight from "@/src/assets/images/light/selected/repo_webhooks.svg";
import repoWebhooksUnselectedLight from "@/src/assets/images/light/unselected/repo_webhooks.svg";
import repoRulesetsSelectedDark from "@/src/assets/images/dark/selected/repo_rulesets.svg";
import repoRulesetsUnselectedDark from "@/src/assets/images/dark/unselected/repo_rulesets.svg";
import repoRulesetsSelectedLight from "@/src/assets/images/light/selected/repo_rulesets.svg";
import repoRulesetsUnselectedLight from "@/src/assets/images/light/unselected/repo_rulesets.svg";
import mergePRIconDark from "@/src/assets/images/dark/action/merge_pr.svg";
import mergePRIconLight from "@/src/assets/images/light/action/merge_pr.svg";
import closePRIconDark from "@/src/assets/images/dark/action/close_pr.svg";
import closePRIconLight from "@/src/assets/images/light/action/close_pr.svg";
import draftIconDark from "@/src/assets/images/dark/action/draft.svg";
import draftIconLight from "@/src/assets/images/light/action/draft.svg";
import reloadIconDark from "@/src/assets/images/dark/action/reload.svg";
import reloadIconLight from "@/src/assets/images/light/action/reload.svg";
import revertIconDark from "@/src/assets/images/dark/action/revert.svg";
import revertIconLight from "@/src/assets/images/light/action/revert.svg";
import errorMark from "@/src/assets/images/neutral/action/error_mark.svg";
import successMark from "@/src/assets/images/neutral/action/success_mark.svg";

import codeReviewerSelectedDark from "@/src/assets/images/dark/selected/code_reviewer.svg";
import codeReviewerUnselectedDark from "@/src/assets/images/dark/unselected/code_reviewer.svg";
import codeReviewerSelectedLight from "@/src/assets/images/light/selected/code_reviewer.svg";
import codeReviewerUnselectedLight from "@/src/assets/images/light/unselected/code_reviewer.svg";

import errorLoggingSelectedDark from "@/src/assets/images/dark/selected/error_logging.svg";
import errorLoggingSelectedLight from "@/src/assets/images/light/selected/error_logging.svg";
import errorLoggingUnselected from "@/src/assets/images/neutral/unselected/error_logging.svg";

import messageIcon from "@/src/assets/images/neutral/action/message.svg";
import groupIcon from "@/src/assets/images/neutral/group.svg";
import newChatIcon from "@/src/assets/images/neutral/new_chat.svg";
import workspaceSpecialCharIcon from "@/src/assets/images/neutral/workspace_special_char_icon.svg";
import nullEntityPlaceholder from "@/src/assets/images/neutral/null_entity_placeholder.svg";

import expandIconDark from "@/src/assets/images/dark/huddle/expand.svg";
import expandIconLight from "@/src/assets/images/light/huddle/expand.svg";
import collapseIconDark from "@/src/assets/images/dark/huddle/collapse.svg";
import collapseIconLight from "@/src/assets/images/light/huddle/collapse.svg";
import muteIconDark from "@/src/assets/images/dark/huddle/mute.svg";
import muteIconLight from "@/src/assets/images/light/huddle/mute.svg";
import videoIconDark from "@/src/assets/images/dark/huddle/video.svg";
import videoIconLight from "@/src/assets/images/light/huddle/video.svg";
import screenShareIconDark from "@/src/assets/images/dark/huddle/screen_share.svg";
import screenShareIconLight from "@/src/assets/images/light/huddle/screen_share.svg";
import mutedIconNeutral from "@/src/assets/images/neutral/huddle/muted.svg";

import atsSelectedDark from "@/src/assets/images/dark/sidebar/selected/ats.svg";
import atsUnselectedDark from "@/src/assets/images/dark/sidebar/unselected/ats.svg";
import atsSelectedLight from "@/src/assets/images/light/sidebar/selected/ats.svg";
import atsUnselectedLight from "@/src/assets/images/light/sidebar/unselected/ats.svg";
import peopleSelectedDark from "@/src/assets/images/dark/sidebar/selected/people.svg";
import peopleUnselectedDark from "@/src/assets/images/dark/sidebar/unselected/people.svg";
import peopleSelectedLight from "@/src/assets/images/light/sidebar/selected/people.svg";
import peopleUnselectedLight from "@/src/assets/images/light/sidebar/unselected/people.svg";
import performSelectedDark from "@/src/assets/images/dark/sidebar/selected/perform.svg";
import performUnselectedDark from "@/src/assets/images/dark/sidebar/unselected/perform.svg";
import performSelectedLight from "@/src/assets/images/light/sidebar/selected/perform.svg";
import performUnselectedLight from "@/src/assets/images/light/sidebar/unselected/perform.svg";
import timeOffSelectedDark from "@/src/assets/images/dark/sidebar/selected/time_off.svg";
import timeOffUnselectedDark from "@/src/assets/images/dark/sidebar/unselected/time_off.svg";
import timeOffSelectedLight from "@/src/assets/images/light/sidebar/selected/time_off.svg";
import timeOffUnselectedLight from "@/src/assets/images/light/sidebar/unselected/time_off.svg";
import attendanceSelectedDark from "@/src/assets/images/dark/sidebar/selected/attendance.svg";
import attendanceUnselectedDark from "@/src/assets/images/dark/sidebar/unselected/attendance.svg";
import attendanceSelectedLight from "@/src/assets/images/light/sidebar/selected/attendance.svg";
import attendanceUnselectedLight from "@/src/assets/images/light/sidebar/unselected/attendance.svg";
import approvalsSelectedDark from "@/src/assets/images/dark/sidebar/selected/approvals.svg";
import approvalsUnselectedDark from "@/src/assets/images/dark/sidebar/unselected/approvals.svg";
import approvalsSelectedLight from "@/src/assets/images/light/sidebar/selected/approvals.svg";
import approvalsUnselectedLight from "@/src/assets/images/light/sidebar/unselected/approvals.svg";
import hrSelectedDark from "@/src/assets/images/dark/selected/hr.svg";
import hrUnselectedDark from "@/src/assets/images/dark/unselected/hr.svg";
import hrSelectedLight from "@/src/assets/images/light/selected/hr.svg";
import hrUnselectedLight from "@/src/assets/images/light/unselected/hr.svg";

export default {
  newChatIcon,
  groupIcon,
  workspaceSpecialCharIcon,
  nullEntityPlaceholder,
  doubleArrowIcon,
  campaignsUnselectedDarkIcon,
  campaignsUnSelectedLightIcon,
  redirectGradientIcon,
  emailVerifiedIcon,
  emailUnverifiedIcon,
  searchIcon,
  searchLightIcon,
  syncIconGrey,
  retryIconGrey,
  emailCampaignWhiteIcon,
  recipientsIconGrey,
  recipientsIconWhite,
  mobileIcon,
  desktopIcon,
  customHtmlIcon,
  plainTextIcon,
  dragNDropIcon,
  campaignsIcon,
  outlinedQuestionMark,
  outlinedQuestionMarkLightIcon,
  entityScoringUnselectedIcon,
  entityScoringSelectedLightIcon,
  addTaskIconGrey,
  roundedQuestionMark,
  autoThemeIconGrey,
  darkThemeIconGrey,
  lightThemeIconGrey,
  goToLinkWhiteLightIcon,
  appCollectionLightIcon,
  setupFormLightIcon,
  defineRoutingLightIcon,
  responseLogsLightIcon,
  promptLightIcon,
  roundedQuestionMarkLightIcon,
  apiKeysSelectedLightIcon,
  customEventsSelectedLightIcon,
  formLightIcon,
  endIconWhiteLightIcon,
  alignCenterIconWhiteLightIcon,
  clearFormattingIconWhiteLightIcon,
  imageIconWhiteLightIcon,
  superAGILightLogo,
  researchSelectedLightIcon,
  closeIconGreyFilled,
  promptIcon,
  entityScoringSelectedIcon,
  lowPriorityTagIcon,
  mediumPriorityTagIcon,
  highPriorityTagIcon,
  appQr,
  downloadFromGooglePlay,
  downloadFromAppStore,
  msTeamsIcon,
  fileIcon,
  zoomIcon,
  cancelIconGrey,
  superSalesAppLogo,
  downArrowWhiteIcon,
  upArrowIcon,
  bookmarkIconGrey,
  sendIconGrey,
  noteIconGrey,
  formIcon,
  embedElementIcon,
  embedInlineIcon,
  blackPlusIcon,
  emptyQuestionIconGrey,
  rightAlignIconWhite,
  emptyStateSecondary,
  analyticsSelectedIcon,
  waterfallSelectedIcon,
  waterfallSelectedLightIcon,
  waterfallUnselectedIcon,
  contentSelectedIcon,
  tasksSelectedIcon,
  tasksUnselectedIcon,
  emptyScreenGreyDarkIcon,
  chartAndTableEmptyScreenGreyDarkIcon,
  callLogsEmptyScreenGreyDarkIcon,
  callQualityEmptyScreenGreyDarkIcon,
  searchEmptyScreenGrey,
  csvFileIcon,
  whatsNewDarkIcon,
  aiSDRSelectedIcon,
  aiSDRUnselectedIcon,
  emptySignalsIconGrey,
  emptySignalsIconGreyLight,
  contentSelectedLightIcon,
  tasksSelectedLightIcon,
  tasksUnselectedLightIcon,
  discordLightIcon,
  chevronArrowRightLightIcon,
  whatsNewLightIcon,
  emptyScreenGreyLightIcon,
  chartAndTableEmptyScreenGreyLightIcon,
  callLogsEmptyScreenGreyLightIcon,
  callQualityEmptyScreenGreyLightIcon,
  prospectEmptyScreenLight,
  prospectEmptyScreenDark,
  xIconGradient,
  linkedinIconGradient,
  whatsappIconGradient,
  facebookIconGradient,
  emailIconGradient,
  customerSuccessDarkSelected,
  customerSuccessDarkUnselected,
  customerSuccessLightSelected,
  customerSuccessLightUnselected,
  customerSuccessSettingsSelectedDark,
  customerSuccessSettingsSelectedLight,
  customerSuccessSettingsUnselectedDark,
  customerSuccessSettingsUnselectedLight,
  businessNameIcon,
  meetings: {
    dark: {
      selected: {
        talktime: talktimeSelectedDark,
        transcript: transcriptSelectedDark,
        meetingIntelligence: meetingIntelligenceSelectedDark,
      },
      unselected: {
        talktime: talktimeUnselectedDark,
        transcript: transcriptUnselectedDark,
        meetingIntelligence: meetingIntelligenceUnselectedDark,
      },
    },

    light: {
      selected: {
        talktime: talktimeSelectedLight,
        transcript: transcriptSelectedLight,
        meetingIntelligence: meetingIntelligenceSelectedLight,
      },
      unselected: {
        talktime: talktimeUnselectedLight,
        transcript: transcriptUnselectedLight,
        meetingIntelligence: meetingIntelligenceUnselectedLight,
      },
    },
  },

  dark: {
    internal: {
      superAGIAcademy: superAGIAcademyDarkIcon,
    },
    chat: {
      chat: chatIconDark,
    },
    call: {
      callIconBlack: callIconBlack,
      contactsLeadsIcon: contactsLeadsIcon,
      onCallIcon: onCallIcon,
      callIconWrapped: callIconWrapped,
      activeDot: activeDot,
    },
    huddle: {
      expandIcon: expandIconDark,
      collapseIcon: collapseIconDark,
      muteIcon: muteIconDark,
      videoIcon: videoIconDark,
      screenShareIcon: screenShareIconDark,
    },
    action: {
      notifications: notificationDarkIcon,
      whatsNew: whatsNewDarkIcon,
      playIcon: playDarkIcon,
      emailAction: emailActionDarkIcon,
      settings: settingsDarkIcon,
      tune: tuneDarkIcon,
      openChat: openChatDarkIcon,
      closeChat: closeChatDarkIcon,
      replied: repliedDarkIcon,
      closeVariant1: closeVariant1DarkIcon,
      pauseVariant1: pauseVariant1DarkIcon,
      searchVariant1: searchIconVariant1DarkIcon,
      panelProject: panelProjectDarkIcon,
      panelAnalytics: panelAnalyticsDarkIcon,
      panelProperty: panelPropertyDarkIcon,
      panelNotes: panelNotesDarkIcon,
      panelRepository: panelRepositoryDarkIcon,
      rename: renameDarkIcon,
      reorder: reorderDarkIcon,
      viewAgenda: viewAgendaDarkIcon,
      backToTasksIcon: backToTasksIcon,
      bannerCrossIcon: bannerCrossIcon,
      defineRouting: defineRouting,
      deliveredIconActive: deliveredIconActive,
      emailStep: emailStep,
      exportMailboxDarkIcon: exportMailboxDarkIcon,
      forwardIcon: forwardIcon,
      goToLinkWhite: goToLinkWhite,
      linkIcon: linkIcon,
      minusIcon: minusIcon,
      outlinedQuestionMark: outlinedQuestionMark,
      overviewIcon: overviewIcon,
      questionMark: questionMark,
      replyAllIcon: replyAllIcon,
      replyIcon: replyIcon,
      resumeIconBlack: resumeIconBlack,
      resumeIconWhite: resumeIconWhite,
      searchIcon: searchIcon,
      sendIconBlackFilled: sendIconBlackFilled,
      sendIconWhite: sendIconWhite,
      setupForm: setupForm,
      skipIcon: skipIcon,
      viewDetailsIcon: viewDetailsIcon,
      warmupIcon: warmupIcon,
      horizontalThreeDots: horizontalThreeDots,
      blackPlusIcon: blackPlusIcon,
      plusIcon: plusIcon,
      prospectSearchDarkIcon: prospectSearchDarkIcon,
      recommendedProspectsDark: recommendedProspectsDark,
      remainingCampaignStep: remainingCampaignStep,
      voiceAgent: voiceAgent,
      automation: automationDarkIcon,
      checkCircleOutlined: checkCircleOutlinedDarkIcon,
      move: moveIconDark,
      appleIcon: appleIconDark,
      forwardGreyIcon: forwardIconGrey,
      code: codeIconDark,
      commits: commitsIconDark,
      pullRequests: pullRequestsIconDark,
      forkRepo: forkRepoIconDark,
      branchRepo: branchRepoIconDark,
      gitActions: gitActionsIconDark,
      githubIcon: githubIconDark,
      mergePR: mergePRIconDark,
      closePR: closePRIconDark,
      draft: draftIconDark,
      reload: reloadIconDark,
      revert: revertIconDark,
    },
    arrows: {
      backArrowWhite: backArrowWhite,
      bottomArrowBlackIcon: bottomArrowBlackIcon,
      bottomArrowWhite: bottomArrowWhite,
      chevronArrowRight: chevronArrowRight,
      downArrowWhiteIcon: downArrowWhiteIcon,
      leftArrowIcon: leftArrowIcon,
      rightArrowDefault: rightArrowDefault,
      sortingArrowSelected: sortingArrowSelected,
      sortingArrowGrey: sortingArrowGrey,
      upArrowIcon: upArrowIcon,
      rightArrowIcon: rightArrowIcon,
    },
    selected: {
      encrypted: encryptedSelectedDarkIcon,
      inboundAgent: inboundAgentSelectedDarkIcon,
      inbox: inboxSelectedDarkIcon,
      agentInstructions: agentInstructionsSelectedDarkIcon,
      knowledgeBase: knowledgeBaseSelectedDarkIcon,
      liveChatWidget: liveChatWidgetSelectedDarkIcon,
      availabilitySelected: availabilitySelected,
      apiKeysSelected: apiKeysSelected,
      customEventsSelected: customEventsSelected,
      billingSelectedIcon: billingSelectedIcon,
      blockListsSelected: blockListsSelected,
      campaignTemplatesSelectedIcon: campaignTemplatesSelectedIcon,
      domainSelected: domainSelected,
      emailTemplatesSelectedIcon: emailTemplatesSelectedIcon,
      entityScoringSelectedIcon: entityScoringSelectedIcon,
      exportSelectedIcon: exportSelectedIcon,
      generalSelectedIcon: generalSelectedIcon,
      integrationsSelectedIcon: integrationsSelectedIcon,
      kanbanViewSelected: kanbanViewSelected,
      linkedinSelectedIcon: linkedinSelectedIcon,
      lockSelectedIcon: lockSelectedIcon,
      mailboxesSelected: mailboxesSelected,
      objectSelectedIcon: objectSelectedIcon,
      outputSelectedIcon: outputSelectedIcon,
      pipelinesSelectedIcon: pipelinesSelectedIcon,
      profileSelectedIcon: profileSelectedIcon,
      repliesSelectedIcon: repliesSelectedIcon,
      researchSelectedIcon: researchSelectedIcon,
      tableViewSelected: tableViewSelected,
      trackingDomainSelected: trackingDomainSelected,
      usersSelectedIcon: usersSelectedIcon,
      voicemailSelectedIcon: voicemailSelectedIcon,
      businessDetailsSelectedIcon: businessDetailsSelectedIcon,
      activeStep: activeStep,
      activityIcon: activityIcon,
      addIcon: addIcon,
      analyticsIcon: analyticsIcon,
      appCollection: appCollection,
      atTheRateSelectedIcon: atTheRateSelectedIcon,
      attachFileIconWhite: attachFileIconWhite,
      promptIcon: promptIcon,
      campaignsIcon: campaignsIcon,
      checkIconBlack: checkIconBlack,
      clickedIconActive: clickedIconActive,
      clockIcon: clockIcon,
      completeCampaignStep: completeCampaignStep,
      emailCampaignWhiteIcon: emailCampaignWhiteIcon,
      endIconWhite: endIconWhite,
      filterActive: filterActive,
      filterIconSelected: filterIconSelected,
      formIcon: formIcon,
      linkedinStep: linkedinStep,
      emailIconWrapped: emailIconWrapped,
      moreIconVertical: moreIconVertical,
      noteIcon: noteIcon,
      previewLeads: previewLeads,
      progressCampaignStep: progressCampaignStep,
      recipientsIconWhite: recipientsIconWhite,
      repliedIconActive: repliedIconActive,
      responseLogs: responseLogs,
      seenIconActive: seenIconActive,
      sentIconActive: sentIconActive,
      taskIcon: taskIcon,
      tickIconWhite: tickIconWhite,
      userIcon: userIcon,
      whiteEnrichSearchIcon: whiteEnrichSearchIcon,
      blackTickIcon: blackTickIcon,
      checkIconRoundedBlack: checkIconRoundedBlack,
      checkIconRoundedWhiteEmpty: checkIconRoundedWhiteEmpty,
      checkIconRoundedWhite: checkIconRoundedWhite,
      infoIcon: infoIcon,
      whatsappSelectedDarkIcon: whatsappSelectedDarkIcon,
      uniboxSettingsIcon: uniboxSettingsSelectedDark,
      uniboxIcon: uniboxSelectedDark,
      developerTools: developerToolsSelectedDark,
      sandbox: sandboxSelectedDark,
      personalTokens: personalTokensSelectedDark,
      codeReviewer: codeReviewerSelectedDark,
      errorLogging: errorLoggingSelectedDark,
      sshKeys: sshKeysSelectedDark,
      repoSettings: repoSettingsSelectedDark,
      repoBranches: repoBranchesSelectedDark,
      repoWebhooks: repoWebhooksSelectedDark,
      repoRulesets: repoRulesetsSelectedDark,
      ats: atsSelectedDark,
      people: peopleSelectedDark,
      perform: performSelectedDark,
      timeOff: timeOffSelectedDark,
      attendance: attendanceSelectedDark,
      approvals: approvalsSelectedDark,
      hr: hrSelectedDark,
    },
    unselected: {
      encrypted: encryptedUnselectedDarkIcon,
      inboundAgent: inboundAgentUnselectedDarkIcon,
      inbox: inboxUnselectedDarkIcon,
      agentInstructions: agentInstructionsUnselectedDarkIcon,
      knowledgeBase: knowledgeBaseUnselectedDarkIcon,
      liveChatWidget: liveChatWidgetUnselectedDarkIcon,
      copyIconUnselected: copyIconUnselected,
      marketingUnselectedDarkIcon: marketingUnselectedDarkIcon,
      moreIconVerticalDisabled: moreIconVerticalDisabled,
      repliedIconInactive: repliedIconInactive,
      seenIconInactive: seenIconInactive,
      uniboxSettingsIcon: uniboxSettingsUnselectedDark,
      uniboxIcon: uniboxUnselectedDark,
      developerTools: developerToolsUnselectedDark,
      sandbox: sandboxUnselectedDark,
      personalTokens: personalTokensUnselectedDark,
      codeReviewer: codeReviewerUnselectedDark,
      errorLogging: errorLoggingUnselected,
      sshKeys: sshKeysUnselectedDark,
      repoSettings: repoSettingsUnselectedDark,
      repoBranches: repoBranchesUnselectedDark,
      repoWebhooks: repoWebhooksUnselectedDark,
      repoRulesets: repoRulesetsUnselectedDark,
      ats: atsUnselectedDark,
      people: peopleUnselectedDark,
      perform: performUnselectedDark,
      timeOff: timeOffUnselectedDark,
      attendance: attendanceUnselectedDark,
      approvals: approvalsUnselectedDark,
      hr: hrUnselectedDark,
    },
    empty: {
      callCampaigns: callCampaignsEmptyScreenDarkIcon,
      profilePlaceholder: profileDarkIconPlaceholder,
      chart: emptyChartDarkPlaceholder,
    },
    common: {
      textEditor: textEditorWhite,
      htmlCode: htmlCodeWhite,
      associations: associationsDarkIcon,
      properties: propertiesDarkIcon,
      hierarchy: hierarchyDarkIcon,
      crmSyncGreyDark: crmSyncGreyDark,
      channelEmail: channelEmailDarkIcon,
    },
    loaders: {
      isTypingIcon: isTypingIcon,
    },
    layout: {
      singleColumn: singleColumnDarkIcon,
      doubleColumn: doubleColumnDarkIcon,
    },
    quill: {
      alignCenterIconWhite: alignCenterIconWhite,
      boldIconWhite: boldIconWhite,
      italicIconWhite: italicIconWhite,
      underlineIconWhite: underlineIconWhite,
      linkIconWhite: linkIconWhite,
      quoteIconWhite: quoteIconWhite,
      numberedListIconWhite: numberedListIconWhite,
      listIconWhite: listIconWhite,
      leftAlignIconWhite: leftAlignIconWhite,
      rightAlignIconWhite: rightAlignIconWhite,
      justifyIconWhite: justifyIconWhite,
      imageIconWhite: imageIconWhite,
      clearFormattingIconWhite: clearFormattingIconWhite,
      plainTextIcon: plainTextIcon,
    },
    icon: {
      suitcaseDarkIcon: suitcaseDarkIcon,
    },
    platform: {
      boltIcon: boltIcon,
      superAGILogo: superAGILogo,
    },
    analytics: {
      type: {
        sql: sqlAnalyticsDarkIcon,
        manual: manualAnalyticsDarkIcon,
      },
      chart: {
        area: areaChartDarkIcon,
        donut: donutChartDarkIcon,
        gauge: gaugeChartDarkIcon,
        horizontal: horizontalChartDarkIcon,
        kpi: kpiChartDarkIcon,
        line: lineChartDarkIcon,
        pie: pieChartDarkIcon,
        scatter: scatterChartDarkIcon,
        table: tableChartDarkIcon,
        vertical: verticalChartDarkIcon,
        funnel: funnelChartDarkIcon,
        pivotTable: pivotTableDarkIcon,
      },
    },
  },

  light: {
    internal: {
      superAGIAcademy: superAGIAcademyLightIcon,
    },
    chat: {
      chat: chatIconLight,
    },
    call: {
      callIconBlackLightIcon: callIconBlackLightIcon,
      activeDotLightIcon: activeDotLightIcon,
      inactiveDotLightIcon: inactiveDotLightIcon,
      onCallLightIcon: onCallLightIcon,
      callIconWrappedLightIcon: callIconWrappedLightIcon,
    },
    huddle: {
      expandIcon: expandIconLight,
      collapseIcon: collapseIconLight,
      muteIcon: muteIconLight,
      videoIcon: videoIconLight,
      screenShareIcon: screenShareIconLight,
    },
    action: {
      notifications: notificationLightIcon,
      whatsNew: whatsNewLightIcon,
      playIcon: playLightIcon,
      emailAction: emailActionLightIcon,
      settings: settingsLightIcon,
      tune: tuneLightIcon,
      openChat: openChatLightIcon,
      closeChat: closeChatLightIcon,
      replied: repliedLightIcon,
      closeVariant1: closeVariant1LightIcon,
      pauseVariant1: pauseVariant1LightIcon,
      searchVariant1: searchIconVariant1LightIcon,
      panelProject: panelProjectLightIcon,
      panelAnalytics: panelAnalyticsLightIcon,
      panelProperty: panelPropertyLightIcon,
      panelNotes: panelNotesLightIcon,
      panelRepository: panelRepositoryLightIcon,
      rename: renameLightIcon,
      reorder: reorderLightIcon,
      viewAgenda: viewAgendaLightIcon,
      sendIconBlack: sendIconBlack,
      addLightIcon: addLightIcon,
      attachFileIconWhiteLightIcon: attachFileIconWhiteLightIcon,
      automation: automationLightIcon,
      defineRoutingLightIcon: defineRoutingLightIcon,
      emailStepLightIcon: emailStepLightIcon,
      enrichSearchLightIcon: enrichSearchLightIcon,
      forwardLightIcon: forwardLightIcon,
      goToLinkWhiteLightIcon: goToLinkWhiteLightIcon,
      horizontalThreeDotsLightIcon: horizontalThreeDotsLightIcon,
      linkLightIcon: linkLightIcon,
      markAsDoneLightIcon: markAsDoneLightIcon,
      emailIconBlackLightIcon: emailIconBlackLightIcon,
      minusLightIcon: minusLightIcon,
      plusLightIcon: plusLightIcon,
      questionMarkLightIcon: questionMarkLightIcon,
      remainingCampaignStepLightIcon: remainingCampaignStepLightIcon,
      replyAllLightIcon: replyAllLightIcon,
      replyLightIcon: replyLightIcon,
      resumeIconBlackLightIcon: resumeIconBlackLightIcon,
      resumeIconGreyLightIcon: resumeIconGreyLightIcon,
      searchEmptyScreenGreyLightIcon: searchEmptyScreenGreyLightIcon,
      searchLightIcon: searchLightIcon,
      sendIconBlackFilledLightIcon: sendIconBlackFilledLightIcon,
      setupFormLightIcon: setupFormLightIcon,
      tickIconWhiteLightIcon: tickIconWhiteLightIcon,
      viewDetailsLightIcon: viewDetailsLightIcon,
      warmupLightIcon: warmupLightIcon,
      voiceAgentPlayLight: voiceAgentPlayLight,
      voiceAgentPauseLight: voiceAgentPauseLight,
      voiceAgentLight: voiceAgentLight,
      checkCircleOutlined: checkCircleOutlinedLightIcon,
      move: moveIconLight,
      appleIcon: appleIconLight,
      forwardGreyIcon: forwardIconGrey,
      code: codeIconLight,
      commits: commitsIconLight,
      pullRequests: pullRequestsIconLight,
      forkRepo: forkRepoIconLight,
      branchRepo: branchRepoIconLight,
      gitActions: gitActionsIconLight,
      githubIcon: githubIconLight,
      mergePR: mergePRIconLight,
      closePR: closePRIconLight,
      draft: draftIconLight,
      reload: reloadIconLight,
      revert: revertIconLight,
    },
    arrows: {
      backArrowWhiteLightIcon: backArrowWhiteLightIcon,
      bottomArrowBlackLightIcon: bottomArrowBlackLightIcon,
      downArrowWhiteLightIcon: downArrowWhiteLightIcon,
      rightArrowDefaultLightIcon: rightArrowDefaultLightIcon,
      sortingArrowSelectedLightIcon: sortingArrowSelectedLightIcon,
      sortingArrowGreyLightIcon: sortingArrowGreyLightIcon,
      upArrowIconLightIcon: upArrowIconLightIcon,
      leftArrowLightIcon: leftArrowLightIcon,
      rightArrowLightIcon: rightArrowLightIcon,
    },
    platform: {
      roundedQuestionMarkLightIcon: roundedQuestionMarkLightIcon,
      superAGILightLogo: superAGILightLogo,
    },
    selected: {
      encrypted: encryptedSelectedLightIcon,
      inboundAgent: inboundAgentSelectedLightIcon,
      inbox: inboxSelectedLightIcon,
      agentInstructions: agentInstructionsSelectedLightIcon,
      knowledgeBase: knowledgeBaseSelectedLightIcon,
      liveChatWidget: liveChatWidgetSelectedLightIcon,
      researchSelectedLightIcon: researchSelectedLightIcon,
      businessDetailsSelectedLightIcon: businessDetailsSelectedLightIcon,
      generalSelectedLightIcon: generalSelectedLightIcon,
      profileSelectedLightIcon: profileSelectedLightIcon,
      integrationsSelectedLightIcon: integrationsSelectedLightIcon,
      emailTemplatesSelectedLightIcon: emailTemplatesSelectedLightIcon,
      usersSelectedLightIcon: usersSelectedLightIcon,
      outputSelectedLightIcon: outputSelectedLightIcon,
      billingSelectedLightIcon: billingSelectedLightIcon,
      voicemailSelectedLightIcon: voicemailSelectedLightIcon,
      linkedinSelectedLightIcon: linkedinSelectedLightIcon,
      pipelinesSelectedLightIcon: pipelinesSelectedLightIcon,
      tableViewSelectedLightIcon: tableViewSelectedLightIcon,
      kanbanViewSelectedLightIcon: kanbanViewSelectedLightIcon,
      campaignTemplatesSelectedLightIcon: campaignTemplatesSelectedLightIcon,
      mailboxesSelectedLightIcon: mailboxesSelectedLightIcon,
      trackingDomainSelectedLightIcon: trackingDomainSelectedLightIcon,
      lockSelectedLightIcon: lockSelectedLightIcon,
      blockListsSelectedLightIcon: blockListsSelectedLightIcon,
      exportSelectedLightIcon: exportSelectedLightIcon,
      availabilitySelectedLightIcon: availabilitySelectedLightIcon,
      objectSelectedLightIcon: objectSelectedLightIcon,
      apiKeysSelectedLightIcon: apiKeysSelectedLightIcon,
      customEventsSelectedLightIcon: customEventsSelectedLightIcon,
      entityScoringSelectedLightIcon: entityScoringSelectedLightIcon,
      domainSelectedLightIcon: domainSelectedLightIcon,
      emailIconBlack: emailIconBlack,
      enrichSearchIcon: enrichSearchIcon,
      exportMailboxLightIcon: exportMailboxLightIcon,
      actionIcon: actionIcon,
      activityLightIcon: activityLightIcon,
      analyticsLightIcon: analyticsLightIcon,
      appCollectionLightIcon: appCollectionLightIcon,
      atTheRateSelectedLightIcon: atTheRateSelectedLightIcon,
      browserLightIcon: browserLightIcon,
      promptLightIcon: promptLightIcon,
      checkIconBlackLightIcon: checkIconBlackLightIcon,
      checkIconRoundedWhiteEmptyLightIcon: checkIconRoundedWhiteEmptyLightIcon,
      checkIconRoundedWhiteLightIcon: checkIconRoundedWhiteLightIcon,
      clickedIconActiveLightIcon: clickedIconActiveLightIcon,
      clockLightIcon: clockLightIcon,
      completeCampaignStepLightIcon: completeCampaignStepLightIcon,
      contactsLeadsLightIcon: contactsLeadsLightIcon,
      conversationsBlankGreyLightIcon: conversationsBlankGreyLightIcon,
      deliveredIconActiveLightIcon: deliveredIconActiveLightIcon,
      emailCampaignSettingsSelectedLightIcon:
        emailCampaignSettingsSelectedLightIcon,
      endIconWhiteLightIcon: endIconWhiteLightIcon,
      filterActiveLightIcon: filterActiveLightIcon,
      formLightIcon: formLightIcon,
      infoLightIcon: infoLightIcon,
      emailIconWrappedLightIcon: emailIconWrappedLightIcon,
      moreIconVerticalLightIcon: moreIconVerticalLightIcon,
      acceptedIconInactive: acceptedIconInactive,
      sentIconInactive: sentIconInactive,
      noteLightIcon: noteLightIcon,
      outlinedQuestionMarkLightIcon: outlinedQuestionMarkLightIcon,
      overviewLightIcon: overviewLightIcon,
      blackPlusLightIcon: blackPlusLightIcon,
      previewLightIcon: previewLightIcon,
      previewLeadsLightIcon: previewLeadsLightIcon,
      progressCampaignStepLightIcon: progressCampaignStepLightIcon,
      prospectSearchLightIcon: prospectSearchLightIcon,
      repliedIconActiveLightIcon: repliedIconActiveLightIcon,
      responseLogsLightIcon: responseLogsLightIcon,
      seenIconActiveLightIcon: seenIconActiveLightIcon,
      taskLightIcon: taskLightIcon,
      userLightIcon: userLightIcon,
      whiteEnrichSearchLightIcon: whiteEnrichSearchLightIcon,
      whiteDotLightIcon: whiteDotLightIcon,
      whatsappSelectedLightIcon: whatsappSelectedLightIcon,
      uniboxSettingsIcon: uniboxSettingsSelectedLight,
      uniboxIcon: uniboxSelectedLight,
      developerTools: developerToolsSelectedLight,
      sandbox: sandboxSelectedLight,
      personalTokens: personalTokensSelectedLight,
      codeReviewer: codeReviewerSelectedLight,
      errorLogging: errorLoggingSelectedLight,
      sshKeys: sshKeysSelectedLight,
      repoSettings: repoSettingsSelectedLight,
      repoBranches: repoBranchesSelectedLight,
      repoWebhooks: repoWebhooksSelectedLight,
      repoRulesets: repoRulesetsSelectedLight,
      ats: atsSelectedLight,
      people: peopleSelectedLight,
      perform: performSelectedLight,
      timeOff: timeOffSelectedLight,
      attendance: attendanceSelectedLight,
      approvals: approvalsSelectedLight,
      hr: hrSelectedLight,
    },
    unselected: {
      encrypted: encryptedUnselectedLightIcon,
      inboundAgent: inboundAgentUnselectedLightIcon,
      inbox: inboxUnselectedLightIcon,
      agentInstructions: agentInstructionsUnselectedLightIcon,
      knowledgeBase: knowledgeBaseUnselectedLightIcon,
      liveChatWidget: liveChatWidgetUnselectedLightIcon,
      copyIconUnselectedLightIcon: copyIconUnselectedLightIcon,
      marketingUnSelectedLightIcon: marketingUnSelectedLightIcon,
      clickedIconInactiveLightIcon: clickedIconInactiveLightIcon,
      crmSyncGreyLight: crmSyncGreyLight,
      deliveredIconInactiveLightIcon: deliveredIconInactiveLightIcon,
      moreIconVerticalDisabledLightIcon: moreIconVerticalDisabledLightIcon,
      noNotificationsIconGreyLightIcon: noNotificationsIconGreyLightIcon,
      repliedIconInactiveLightIcon: repliedIconInactiveLightIcon,
      seenIconInactiveLightIcon: seenIconInactiveLightIcon,
      uniboxSettingsIcon: uniboxSettingsUnselectedLight,
      uniboxIcon: uniboxUnselectedLight,
      developerTools: developerToolsUnselectedLight,
      sandbox: sandboxUnselectedLight,
      personalTokens: personalTokensUnelectedLight,
      codeReviewer: codeReviewerUnselectedLight,
      errorLogging: errorLoggingUnselected,
      sshKeys: sshKeysUnselectedLight,
      repoSettings: repoSettingsUnselectedLight,
      repoBranches: repoBranchesUnselectedLight,
      repoWebhooks: repoWebhooksUnselectedLight,
      repoRulesets: repoRulesetsUnselectedLight,
      ats: atsUnselectedLight,
      people: peopleUnselectedLight,
      perform: performUnselectedLight,
      timeOff: timeOffUnselectedLight,
      attendance: attendanceUnselectedLight,
      approvals: approvalsUnselectedLight,
      hr: hrUnselectedLight,
    },
    empty: {
      callCampaigns: callCampaignsEmptyScreenLightIcon,
      profilePlaceholder: profileLightIconPlaceholder,
      chart: emptyChartLightPlaceholder,
    },
    common: {
      textEditor: textEditorBlack,
      htmlCode: htmlCodeBlack,
      associations: associationsLightIcon,
      properties: propertiesLightIcon,
      hierarchy: hierarchyLightIcon,
      channelEmail: channelEmailLightIcon,
    },
    icon: {
      linkedinStepLightIcon: linkedinStepLightIcon,
      suitcaseLightIcon: suitcaseLightIcon,
    },
    layout: {
      singleColumn: singleColumnLightIcon,
      doubleColumn: doubleColumnLightIcon,
    },
    loaders: {
      isTypingLightIcon: isTypingLightIcon,
    },
    analytics: {
      type: {
        sql: sqlAnalyticsLightIcon,
        manual: manualAnalyticsLightIcon,
      },
      chart: {
        area: areaChartLightIcon,
        donut: donutChartLightIcon,
        gauge: gaugeChartLightIcon,
        horizontal: horizontalChartLightIcon,
        kpi: kpiChartLightIcon,
        line: lineChartLightIcon,
        pie: pieChartLightIcon,
        scatter: scatterChartLightIcon,
        table: tableChartLightIcon,
        vertical: verticalChartLightIcon,
        funnel: funnelChartLightIcon,
        pivotTable: pivotTableLightIcon,
      },
    },
    quill: {
      alignCenterIconWhiteLightIcon: alignCenterIconWhiteLightIcon,
      boldIconWhiteLightIcon: boldIconWhiteLightIcon,
      italicIconWhiteLightIcon: italicIconWhiteLightIcon,
      underlineIconWhiteLightIcon: underlineIconWhiteLightIcon,
      linkIconWhiteLightIcon: linkIconWhiteLightIcon,
      quoteIconWhiteLightIcon: quoteIconWhiteLightIcon,
      numberedListIconWhiteLightIcon: numberedListIconWhiteLightIcon,
      listIconWhiteLightIcon: listIconWhiteLightIcon,
      leftAlignIconWhiteLightIcon: leftAlignIconWhiteLightIcon,
      rightAlignIconWhiteLightIcon: rightAlignIconWhiteLightIcon,
      justifyIconWhiteLightIcon: justifyIconWhiteLightIcon,
      imageIconWhiteLightIcon: imageIconWhiteLightIcon,
      clearFormattingIconWhiteLightIcon: clearFormattingIconWhiteLightIcon,
      leftAlignIcon: leftAlignIcon,
    },
  },

  neutral: {
    country: {
      USFlag: USFlag,
      CAFlag: CAFlag,
      UKFlag: UKFlag,
      NZFlag: NZFlag,
      CHFlag: CHFlag,
      INFlag: INFlag,
      AUFlag: AUFlag,
      SGFlag: SGFlag,
      BRFlag: BRFlag,
      IEFlag: IEFlag,
      MYFlag: MYFlag,
      multilingualFlag: multilingualFlag,
    },
    alerts: {
      warningIconTriangle: warningIconTriangle,
    },
    huddle: {
      mutedIcon: mutedIconNeutral,
    },
    action: {
      resizeIcon: resizeIcon,
      addPurpleIcon: addPurpleIcon,
      checkCircle: checkCircleIcon,
      checkCircleDisabled: checkCircleDisabledIcon,
      checkIcon: checkIcon,
      verifiedYellow: verifiedYellowIcon,
      addVariant1White: addVariant1WhiteIcon,
      removeVariant1Black: removeVariant1BlackIcon,
      verticalWhiteLine: verticalWhiteLine,
      contactsLeadsGrey: contactsLeadsGreyIcon,
      validationGreenTick: validationGreenTickIcon,
      validationStepError: validationStepErrorIcon,
      plusGrey: plusGrey,
      share: shareNeutralIcon,
      linkIconGrey: linkIconGrey,
      microphone: microphone,
      voiceAiIcon: voiceAiIcon,
      voiceAiIconDark: voiceAiIconDark,
      agiAssistantLightning: agiAssistantLightning,
      openChat: openChatNeutralIcon,
      closeChat: closeChatNeutralIcon,
      plusGreyThin: plusGreyThin,
      eyeOffIconGrey: eyeOffIconGrey,
      eyeIconGrey: eyeIconGrey,
      sortAscendingNeutral: sortAscendingNeutral,
      sortDescendingNeutral: sortDescendingNeutral,
      pin: pinIcon,
      unpin: unpinIcon,
      addMemberOption: addMemberOption,
      moreIconGrey: moreIconGrey,
      editV2: editV2Icon,
      arrowOutward: arrowOutwardIcon,
      websiteUnpublish: websiteUnpublishIcon,
      propertyVisibilityGrey: propertyVisibilityGreyIcon,
      dashboardGrey: dashboardGreyIcon,
      tableGrey: tableGreyIcon,
      boardGrey: boardGreyIcon,
      cardsGrey: cardsGreyIcon,
      downloadFromAppStore: downloadFromAppStore,
      downloadFromGooglePlay: downloadFromGooglePlay,
      acceptedIconActive: acceptedIconActive,
      clickedIconGreen: clickedIconGreen,
      crossMark: crossMark,
      deliveredIconGreen: deliveredIconGreen,
      emailUnverifiedIcon: emailUnverifiedIcon,
      emailVerifiedIcon: emailVerifiedIcon,
      greenCheckIcon: greenCheckIcon,
      redCloseIcon: redCloseIcon,
      repliedIconGreen: repliedIconGreen,
      resumeIconGrey: resumeIconGrey,
      seenIconGreen: seenIconGreen,
      tickMark: tickMark,
      addIconBlack: addIconBlack,
      buildFromScratch: buildFromScratchIcon,
      playIconGrey: playIconGrey,
      editSquare: editSquare,
      numberGrey: numberGrey,
      booleanGrey: booleanGrey,
      percentageGrey: percentageGrey,
      conversionRate: conversionRateIcon,
      message: messageIcon,
      microsoftIcon: microsoftIcon,
      errorMark: errorMark,
      successMark: successMark,
    },
    arrows: {
      arrowDownTooltipGrey: arrowDownTooltipGrey,
      backArrowVariant1Grey: backArrowVariant1Grey,
      backArrowDefaultGrey: backArrowDefaultGrey,
      bottomArrowGrey: bottomArrowGrey,
      chevronArrowLeftGrey: chevronArrowLeftGrey,
      downArrowIconGrey: downArrowIconGrey,
      leftArrowGreyIcon: leftArrowGreyIcon,
      rightArrowSmallGrey: rightArrowSmallGrey,
      arrowChevron1: arrowChevron1,
    },
    common: {
      contentPasteSearch: contentPasteSearch,
      checkCircle2: checkCircle2,
      blockRed: blockRed,
      removedUser: removedUser,
      textEditorGrey: textEditorGrey,
      htmlCodeGrey: htmlCodeGrey,
      anonymous: anonymousIcon,
      msg91: msg91Icon,
      associations: associationsNeutralIcon,
      properties: propertiesNeutralIcon,
      unassignedProfile: unassignedProfile,
      manageColumnsIcon: manageColumnsIcon,
      projectGrey: projectGreyIcon,
      tableGrey: tableGreyIcon,
      boardGrey: boardGreyIcon,
      hierarchy: hierarchyIcon,
      parentObject: parentObjectGreyIcon,
      childObject: childObjectGreyIcon,
      automaticEmailWrapped: automaticEmailWrapped,
      existingContactIconGrey: existingContactIconGrey,
      existingLeadIconGrey: existingLeadIconGrey,
      calculateGrey: calculateGreyIcon,
      adsClick: adsClickIcon,
      compareArrows: compareArrowsIcon,
      clockGrey: clockGrey,
    },
    grey: {
      accessFolderGreyIcon: accessFolderGreyIcon,
      addTaskIconGrey: addTaskIconGrey,
      aiSDRGreyIcon: aiSDRGreyIcon,
      analyticsGreyIcon: analyticsGreyIcon,
      cancelIconGrey: cancelIconGrey,
      closeIconGreyFilled: closeIconGreyFilled,
      companiesGreyIcon: companiesGreyIcon,
      contactsGreyIcon: contactsGreyIcon,
      crossGreyIcon: crossGreyIcon,
      dealsGreyIcon: dealsGreyIcon,
      leadsGreyIcon: leadsGreyIcon,
      noteIconGrey: noteIconGrey,
      retryIconGrey: retryIconGrey,
      addRoundedGreyIcon: addRoundedGreyIcon,
      addIconGrey: addIconGrey,
      addStepIconGrey: addStepIconGrey,
      addToSequenceGrey: addToSequenceGrey,
      assignOwnerIconGrey: assignOwnerIconGrey,
      atTheRateIconGrey: atTheRateIconGrey,
      attachFileIconGrey: attachFileIconGrey,
      autoThemeIconGrey: autoThemeIconGrey,
      automaticEmailGrey: automaticEmailGrey,
      backspaceIconGrey: backspaceIconGrey,
      billingIconGrey: billingIconGrey,
      boldTickIconGrey: boldTickIconGrey,
      bookmarkIconGrey: bookmarkIconGrey,
      calculatorIcon: calculatorIcon,
      calendarIconGrey: calendarIconGrey,
      calendarTickIconGrey: calendarTickIconGrey,
      callIconGrey: callIconGrey,
      checkListIconGrey: checkListIconGrey,
      clickedIconInactive: clickedIconInactive,
      cloneIconGrey: cloneIconGrey,
      closeIconGrey: closeIconGrey,
      codeIconGrey: codeIconGrey,
      conversationsBlankGrey: conversationsBlankGrey,
      copyIconGrey: copyIconGrey,
      customHtmlIcon: customHtmlIcon,
      curlyBraceIconGrey: curlyBraceIconGrey,
      darkThemeIconGrey: darkThemeIconGrey,
      deleteIconGrey: deleteIconGrey,
      deliveredIconInactive: deliveredIconInactive,
      desktopIcon: desktopIcon,
      disconnectIconGrey: disconnectIconGrey,
      documentIconGrey: documentIconGrey,
      downloadIconGrey: downloadIconGrey,
      printIconGrey: printIconGrey,
      dragNDropIcon: dragNDropIcon,
      draggableDots: draggableDots,
      resizeGrip: resizeGrip,
      signalWave: signalWave,
      dustbinIconGrey: dustbinIconGrey,
      calendarEditGrey: calendarEditGrey,
      editIcon: editIcon,
      emailCampaignSettingsUnselectedIcon: emailCampaignSettingsUnselectedIcon,
      emailIconGrey: emailIconGrey,
      emojiIconGrey: emojiIconGrey,
      enclosedCrossGrey: enclosedCrossGrey,
      encryptionIconGrey: encryptionIconGrey,
      expandIconGrey: expandIconGrey,
      exportIconGrey: exportIconGrey,
      fileIcon: fileIcon,
      filterIconGrey: filterIconGrey,
      goToLinkGrey: goToLinkGrey,
      horizontalThreeDotsGrey: horizontalThreeDotsGrey,
      infoIconGrey: infoIconGrey,
      inverseIconGrey: inverseIconGrey,
      lightThemeIconGrey: lightThemeIconGrey,
      linkGreyIcon: linkGreyIcon,
      linkedinIconGrey: linkedinIconGrey,
      loadBalancingIconGrey: loadBalancingIconGrey,
      lockIconGrey: lockIconGrey,
      logoutIconGrey: logoutIconGrey,
      mailIconGrey: mailIconGrey,
      manualIconGrey: manualIconGrey,
      marketResearchIconGrey: marketResearchIconGrey,
      meetingIconGrey: meetingIconGrey,
      mobileIcon: mobileIcon,
      multiThreadingIconGrey: multiThreadingIconGrey,
      nextBestActionIconGrey: nextBestActionIconGrey,
      notAllowedIconGrey: notAllowedIconGrey,
      openInFullMode: openInFullMode,
      pauseIconGrey: pauseIconGrey,
      previewEyeIconGrey: previewEyeIconGrey,
      prospectingBrowserIconGrey: prospectingBrowserIconGrey,
      prospectingLinkedinIconGrey: prospectingLinkedinIconGrey,
      qualificationIconGrey: qualificationIconGrey,
      recipientsIconGrey: recipientsIconGrey,
      referIconGrey: referIconGrey,
      removeListIconGrey: removeListIconGrey,
      removeNoteGrey: removeNoteGrey,
      removeIconGrey: removeIconGrey,
      revokeIconGrey: revokeIconGrey,
      roundRobinIconGrey: roundRobinIconGrey,
      selectManualIconGrey: selectManualIconGrey,
      sendIconGrey: sendIconGrey,
      settingsIconGrey: settingsIconGrey,
      signatureIconGrey: signatureIconGrey,
      smsIconGrey: smsIconGrey,
      stackedEmailGrey: stackedEmailGrey,
      starIconGrey: starIconGrey,
      starFilledIconGrey: starFilledIconGrey,
      switchIconGrey: switchIconGrey,
      syncIconGrey: syncIconGrey,
      tickIconGrey: tickIconGrey,
      toLeftArrow: toLeftArrow,
      uploadCsvIconGrey: uploadCsvIconGrey,
      uploadIcon1Grey: uploadIcon1Grey,
      uploadIconGrey: uploadIconGrey,
      viaIconGrey: viaIconGrey,
      viewDetailsExpandIconGrey: viewDetailsExpandIconGrey,
      whatsappIconGrey: whatsappIconGrey,
      orderedListIconGrey: orderedListIconGrey,
      noNotificationsIconGrey: noNotificationsIconGrey,
      noTemplateIconGrey: noTemplateIconGrey,
      imageIconGrey: imageIconGrey,
      videoIconGrey: videoIconGrey,
      cameraIconGrey: cameraIconGrey,
    },
    info: {
      redInfo: redInfo,
      yellowWarning: yellowWarning,
      blueAnnouncement: blueAnnouncement,
      warningIcon: warningIcon,
      lowPriority: lowPriority,
      lowPriorityTagIcon: lowPriorityTagIcon,
      markedAsDoneIcon: markedAsDoneIcon,
      mediumPriority: mediumPriority,
      mediumPriorityTagIcon: mediumPriorityTagIcon,
      orangeDot: orangeDot,
      blackDot: blackDot,
      checkGreenIcon: checkGreenIcon,
      greenDot: greenDot,
      highPriorityTagIcon: highPriorityTagIcon,
      highPriority: highPriority,
      inactiveDot: inactiveDot,
      redDot: redDot,
      signalsHigh: signalsHigh,
      signalsLow: signalsLow,
      signalsMedium: signalsMedium,
      whiteDot: whiteDot,
    },
    icon: {
      discordIcon: discordIcon,
      linkedin: linkedin,
      sendsparkIcon: sendsparkIcon,
      zoomIcon: zoomIcon,
      superagiFooter: superagiFooterIcon,
      propertyTypeText: propertyTypeTextIcon,
      propertyTypeNumber: propertyTypeNumberIcon,
      propertyTypeSelect: propertyTypeSelectIcon,
      propertyTypeMultiSelect: propertyTypeMultiSelectIcon,
      propertyTypeDate: propertyTypeDateIcon,
      propertyTypeDatetime: propertyTypeDatetimeIcon,
      propertyTypeUrl: propertyTypeUrlIcon,
      propertyTypeEmail: propertyTypeEmailIcon,
      propertyTypePhone: propertyTypePhoneIcon,
      propertyTypeUser: propertyTypeUserIcon,
      propertyTypeBoolean: propertyTypeBooleanIcon,
      domain: domainIconGrey,
      linkedinWrapped: linkedinWrapped,
    },
    integration: {
      zoom: zoomIntegration,
      msTeams: msTeamsIntegration,
      googleMeet: googleMeetIntegration,
      msTeamsIcon: msTeamsIcon,
      outlookLogo: outlookLogo,
      outlookCalendarIcon: outlookCalendarIcon,
      gmailLogo: gmailLogo,
      googleCalendarIcon: googleCalendarIcon,
      googleMeetIcon: googleMeetIcon,
    },
    platform: {
      appQr: appQr,
      agiMark: agiMark,
      onboardingImage: onboardingImage,
      roundedQuestionMark: roundedQuestionMark,
      superMeetIcon: superMeetIcon,
      superSalesAppLogo: superSalesAppLogo,
      superAGILogoRound: superAGILogoRound,
      superAgiNameLogo: superAgiNameLogo,
      superAgiNameFullLogo: superAgiNameFullLogo,
      curlyBraceWithLightningIcon: curlyBraceWithLightningIcon,
    },
    selected: {
      starRate: starRateSelectedIcon,
    },
    unselected: {
      starRate: starRateUnselectedIcon,
      apiKeysUnselected: apiKeysUnselected,
      customEventsUnselected: customEventsUnselected,
      availabilityUnselected: availabilityUnselected,
      billingUnselectedIcon: billingUnselectedIcon,
      blockListsUnselected: blockListsUnselected,
      businessDetailsUnselectedIcon: businessDetailsUnselectedIcon,
      campaignTemplatesUnselectedIcon: campaignTemplatesUnselectedIcon,
      trackingDomainUnselected: trackingDomainUnselected,
      emailTemplatesUnselectedIcon: emailTemplatesUnselectedIcon,
      entityScoringUnselectedIcon: entityScoringUnselectedIcon,
      exportUnSelectedIcon: exportUnSelectedIcon,
      generalUnselectedIcon: generalUnselectedIcon,
      integrationsUnselectedIcon: integrationsUnselectedIcon,
      kanbanViewUnselected: kanbanViewUnselected,
      linkedinUnSelectedIcon: linkedinUnSelectedIcon,
      lockUnselectedIcon: lockUnselectedIcon,
      mailboxesUnselected: mailboxesUnselected,
      objectUnselectedIcon: objectUnselectedIcon,
      outputUnselectedIcon: outputUnselectedIcon,
      pipelinesUnselectedIcon: pipelinesUnselectedIcon,
      profileUnselectedIcon: profileUnselectedIcon,
      repliesUnselectedIcon: repliesUnselectedIcon,
      researchUnselectedIcon: researchUnselectedIcon,
      tableViewUnselected: tableViewUnselected,
      usersUnselectedIcon: usersUnselectedIcon,
      voicemailUnselectedIcon: voicemailUnselectedIcon,
      domainUnselected: domainUnselected,
      errorLoggingUnselected: errorLoggingUnselected,
    },
    card: {
      ai: aiCardNeutralIcon,
      table: tableCardNeutralIcon,
      number: numberCardNeutralIcon,
      graph: graphCardNeutralIcon,
      embedElementIcon: embedElementIcon,
      embedInlineIcon: embedInlineIcon,
    },
  },
};
